// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../bundler/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../bundler/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.anna-shell {
    background: var(--anna-surface);
    display: flex;
    flex-direction: column;
    height: 100%;
    width: 100%;
    flex: 1;
    min-height: 0;
    overflow: hidden;
}
.anna-shell *:not(.anna-workspace-content, .anna-workspace-content *) {
    box-sizing: border-box;
}
.anna-shell button:not(.anna-workspace-content *),
.anna-shell textarea:not(.anna-workspace-content *),
.anna-shell a:not(.anna-workspace-content *) {
    font: inherit;
}
.anna-shell button:not(.anna-workspace-content *) {
    cursor: pointer;
}
.anna-shell button:not(.anna-workspace-content *):disabled {
    opacity: 0.45;
    cursor: default;
}
.anna-shell button:not(.anna-workspace-content *):focus-visible,
.anna-shell a:not(.anna-workspace-content *):focus-visible,
.anna-shell textarea:not(.anna-workspace-content *):focus-visible {
    outline: 2px solid var(--anna-accent);
    outline-offset: 3px;
}
.anna-header {
    min-height: 72px;
    flex: none;
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
    align-items: center;
    gap: 8px;
    flex-wrap: nowrap;
    padding: 16px 24px;
    border-bottom: 1px solid var(--anna-border);
    background: #fff;
}
.anna-header-left,
.anna-header-right {
    display: flex;
    align-items: center;
    gap: inherit;
    min-width: 0;
}
.anna-header-sidebar {
    grid-template-columns: minmax(0, 1fr) auto;
}
.anna-header-right {
    justify-content: flex-end;
}
.anna-header-tasks {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 44px;
    height: 36px;
    padding: 0 4px;
    border: 0;
    border-radius: 6px;
    background: transparent;
    color: var(--anna-muted);
}
.anna-header-tasks:hover {
    background: var(--anna-tint);
    color: var(--anna-accent);
}
.anna-task-icon {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 28px;
    height: 28px;
    flex: none;
}
.anna-brand {
    color: var(--anna-ink);
    font-size: 14px;
    font-weight: 500;
    line-height: 18px;
    display: block;
    overflow: hidden;
    white-space: normal;
    overflow-wrap: anywhere;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
}
.anna-header-note {
    color: var(--anna-muted);
    font-size: 13px;
}
.anna-search {
    margin-left: auto;
    border: 0;
    background: none;
    color: var(--anna-ink);
    font-size: 13px !important;
}
.anna-workspace-link {
    color: var(--anna-ink);
    text-decoration: none;
    font-size: 13px !important;
}
.anna-layout {
    display: grid;
    grid-template-columns: minmax(330px, 38%) minmax(0, 1fr);
    flex: 1;
    min-height: 0;
}
.anna-conversation {
    display: flex;
    flex-direction: column;
    min-height: 0;
    min-width: 0;
    border-right: 1px solid var(--anna-border);
    background: #fff;
    position: relative;
}
.anna-header-assistant {
    display: flex;
    flex: 0 1 auto;
    min-width: 0;
    gap: 8px;
    align-items: center;
    padding: 0;
    border: 0;
    border-radius: 8px;
    background: none;
    color: var(--anna-ink);
    text-align: left;
}
.anna-header-assistant:hover .anna-brand {
    color: var(--anna-accent);
}
.anna-open-tasks-badge {
    position: absolute;
    top: 0;
    left: 14px;
    display: inline-flex;
}
.anna-header-details {
    display: flex;
    flex: 1;
    min-width: 0;
    align-items: center;
    gap: 16px;
}
.anna-header-identity {
    min-width: 0;
    max-width: 360px;
    flex: 0 1 auto;
}
.anna-small-avatar {
    width: 30px;
    height: 30px;
    flex: none;
    border-radius: 50%;
    background: var(--anna-tint);
    overflow: hidden;
    display: grid;
    place-items: center;
}
.anna-small-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.anna-header-identity > span {
    display: block;
    max-width: 220px;
    margin-top: 3px;
    font-size: 12px;
    color: var(--anna-muted);
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}
.anna-shell i:not(.anna-workspace-content *) {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: var(--anna-accent);
}
.anna-context-notice {
    display: flex;
    min-width: 0;
    align-items: baseline;
    margin: 16px 0;
    color: var(--anna-muted);
    font-size: 12px;
    line-height: 1.5;
    gap: 12px;
}
.anna-context-notice span {
    flex: 1;
    overflow-wrap: anywhere;
}
.anna-context-notice time {
    flex: none;
    font-size: 10px;
    white-space: nowrap;
}
.anna-activity-notice a {
    display: flex;
    flex: 1;
    min-width: 0;
    align-items: baseline;
    gap: 6px;
    color: var(--anna-muted);
    text-decoration: none;
}
.anna-activity-notice a:hover {
    text-decoration: none;
}
.anna-activity-content {
    display: flex;
    flex-direction: column;
    min-width: 0;
    gap: 3px;
}
.anna-activity-title {
    overflow: hidden;
    color: var(--anna-ink);
    font-weight: 500;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.anna-activity-content > span {
    flex: none;
}
.anna-activity-actions {
    display: flex;
    flex-wrap: wrap;
    min-width: 0;
    gap: 4px;
}
.anna-activity-action,
.anna-activity-link {
    display: inline-flex;
    align-items: center;
    box-sizing: border-box;
    /* A chip never gets wider than its row (AT-2918): "Mit Ziel verknüpft: <long goal name>"
       otherwise pushed the row past a narrow chat pane. One line, ellipsis, full text in the
       title; the whole row stays the link to the object. */
    max-width: 100%;
    min-width: 0;
    overflow: hidden;
    padding: 0 6px;
    border-radius: 999px;
    background: var(--anna-tint);
    font-size: 10px;
    line-height: 16px;
    white-space: nowrap;
}
/* text-overflow needs a block container, not a flex container, so the action chip (text only)
   is a block; it still sits in the wrapping .anna-activity-actions row. */
.anna-activity-actions > .anna-activity-action {
    display: block;
    flex: 0 1 auto;
    text-overflow: ellipsis;
}
.anna-activity-link {
    gap: 3px;
    margin: 0 2px;
    vertical-align: baseline;
    color: var(--anna-accent);
}
.anna-activity-link > .anna-activity-link-label {
    flex: 0 1 auto;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
}
.anna-activity-preview,
.anna-activity-meta {
    color: var(--anna-muted);
}
/* A preview hints at the message; the object holds the rest (AT-2906). */
.anna-activity-preview {
    display: -webkit-box;
    overflow: hidden;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}
.anna-activity-meta {
    overflow: hidden;
    font-size: 10px;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.anna-activity-notice a > :last-child {
    flex-shrink: 0;
    color: var(--anna-accent);
}
.anna-messages {
    /* The conversation scrolls vertically only (AT-2917). Wide content owns its own
       horizontal scroller (tables) or wraps; a sideways swipe must never move the chat. */
    overflow-x: hidden;
    overflow-y: auto;
    flex: 1;
    min-height: 0;
    padding: 16px 24px 24px;
    overscroll-behavior: contain;
    overflow-wrap: anywhere;
    /* The follow controller owns anchoring. Browser anchoring would race it. */
    overflow-anchor: none;
    scrollbar-gutter: stable;
    scroll-behavior: auto;
}
.anna-message-timeline {
    display: flow-root;
}
.anna-message-answer {
    animation: anna-answer-arrive 160ms ease-out;
}
.anna-messages:focus-visible {
    outline: 2px solid var(--anna-focus);
    outline-offset: -2px;
}
.anna-welcome {
    padding: 48px 4px 28px;
}
.anna-eyebrow {
    font-size: 11px;
    letter-spacing: 1.5px;
    text-transform: uppercase;
    color: var(--anna-muted);
}
.anna-welcome h1 {
    font-size: 34px;
    font-weight: 400;
    letter-spacing: -1.1px;
    line-height: 1.2;
    margin: 16px 0;
}
.anna-welcome p {
    color: var(--anna-muted);
    font-size: 15px;
    line-height: 1.65;
    margin: 0 0 30px;
}
.anna-suggestions {
    display: flex;
    flex-direction: column;
    gap: 9px;
    align-items: flex-start;
}
.anna-suggestions button {
    border: 1px solid var(--anna-border);
    background: var(--anna-surface);
    border-radius: 9px;
    color: var(--anna-ink);
    padding: 11px 14px;
    font-size: 13px;
    text-align: left;
}
.anna-message {
    border-radius: 12px;
    margin: 0 0 24px;
    padding: 10px 0;
    min-width: 0;
    animation: anna-message-arrive 180ms ease-out both;
}
.anna-message-user {
    margin-left: 32px;
    background: var(--anna-neutral);
    padding: 14px 16px;
    border: 1px solid var(--anna-border);
}
/* AT-2922: written while the previous answer was still running; sent once it is complete.
   AT-2927: only the message fades. The queued note stays at full strength so it reads as the
   state of the message rather than as more faded text. */
.anna-message-queued > :not(.anna-message-queue-note) {
    opacity: 0.6;
}
.anna-message-queue-note {
    min-width: 0;
    margin: -2px 0 10px;
}
.anna-message-author {
    display: flex;
    gap: 6px;
    align-items: center;
    font-size: 12px;
    font-weight: 500;
    margin-bottom: 8px;
    color: var(--anna-muted);
}
.anna-message-avatar {
    display: flex;
    flex: none;
    width: 20px;
    height: 20px;
}
.anna-message-author-name {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.anna-message-text {
    white-space: pre-wrap;
    overflow-wrap: anywhere;
    font-size: 14px;
    line-height: 1.5;
}
.anna-message-status {
    display: block;
    margin-top: 8px;
    color: var(--anna-muted);
    font-size: 11px;
}
.anna-message-author time {
    margin-left: auto;
    flex-shrink: 0;
    font-size: 10px;
    font-weight: 400;
}
.anna-composer {
    flex: none;
    margin: 0 22px;
    padding: 8px 0 max(8px, env(safe-area-inset-bottom));
    container: anna-composer / inline-size;
}
.anna-composer-slot {
    position: relative;
}
.anna-composer-slot-connecting .anna-composer-field {
    visibility: hidden;
}
.anna-composer-connecting {
    position: absolute;
    inset: 0;
    display: flex;
    border-radius: 20px;
}
.anna-composer-cancel {
    position: absolute;
    bottom: 2px;
    right: 8px;
    font-size: 11px !important;
}
.anna-composer-field {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 14px 12px 10px;
    border: 1px solid var(--anna-border);
    background: var(--anna-surface);
    border-radius: 20px;
    transition:
        border-color 150ms ease,
        box-shadow 150ms ease;
}
.anna-composer-draft {
    display: flex;
    flex-direction: column;
    gap: 8px;
    min-width: 0;
}
.anna-composer-slot-voice .anna-composer-draft {
    visibility: hidden;
    pointer-events: none;
}
.anna-rich-composer {
    min-width: 0;
    width: 100%;
}
.anna-rich-composer .ql-container,
.anna-rich-composer .ql-editor {
    background: transparent;
    border: 0;
    color: var(--anna-ink) !important;
    font-size: 16px !important;
    line-height: 24px !important;
}
.anna-rich-composer .ql-editor {
    min-height: 48px;
    padding: 0 4px !important;
    overflow-y: visible !important;
}
.anna-rich-composer .ql-container > .ql-editor > p {
    line-height: 24px;
}
.anna-rich-composer .ql-container > .ql-editor.ql-blank::before {
    color: var(--anna-placeholder);
    /* Match the editor's text inset instead of the shared task placeholder offsets. */
    top: 0;
    left: 4px !important;
    right: 4px !important;
}
.anna-composer-field:focus-within {
    border-color: var(--anna-focus);
    box-shadow: 0 0 0 1px var(--anna-focus);
}
.anna-shell .anna-rich-composer .ql-editor:focus-visible {
    outline: none;
}
.anna-composer-toolbar,
.anna-composer-tools,
.anna-composer-actions {
    display: flex;
    align-items: center;
    gap: 8px;
}
.anna-composer-toolbar {
    justify-content: space-between;
}
.anna-composer-attachment {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    flex: none;
}
.anna-send {
    width: 40px;
    height: 40px;
    flex: none;
    display: grid;
    place-items: center;
    padding: 0;
    border: 0;
    border-radius: 50%;
    background: var(--anna-accent);
    color: white;
    transition:
        box-shadow 150ms ease,
        opacity 150ms ease;
}
.anna-send:not(:disabled):hover {
    box-shadow: 0 2px 8px #0c66ff33;
}
.anna-voice-button {
    width: 40px;
    height: 40px;
    flex: none;
    display: grid;
    place-items: center;
    padding: 0;
    border: 0;
    border-radius: 50%;
    background: transparent;
    color: var(--anna-muted);
}
.anna-voice-button:hover {
    background: var(--anna-hover);
}
.anna-voice-active,
.anna-voice-active:hover {
    color: #a12f36;
    background: #fbefef;
}
.anna-composer-footer {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    font-size: 11px;
    color: var(--anna-muted);
    padding: 8px 4px 2px;
    white-space: nowrap;
    min-width: 0;
}
.anna-composer-footer > span {
    overflow: hidden;
    text-overflow: ellipsis;
}
.anna-composer-shortcut {
    flex: none;
}
.anna-composer-footer-idle {
    justify-content: flex-end;
}
.anna-call-audio {
    position: absolute;
    inset: 0;
    padding: 14px 12px 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 8px;
}
.anna-call-summary {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    min-height: 48px;
    min-width: 0;
}
.anna-call-levels {
    display: flex;
    gap: 10px;
    flex: none;
}
.anna-call-level {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 5px 8px;
    border: 1px solid var(--anna-border);
    border-radius: 12px;
    background: var(--anna-surface);
    color: #227c60;
    --anna-meter-color: #36a77b;
}
.anna-call-level-output {
    color: #5964bb;
    --anna-meter-color: #7b87ed;
}
.anna-call-settings {
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 14px;
    padding: 16px;
    overflow: auto;
    border: 1px solid #e4e9ee;
    border-radius: 16px;
    background: #fff;
    color: #18283f;
    box-shadow: 0 8px 32px #18283f24;
    font:
        14px / 1.4 -apple-system,
        BlinkMacSystemFont,
        'Segoe UI',
        sans-serif;
}
.anna-call-settings * {
    box-sizing: border-box;
}
.anna-call-settings-heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
}
.anna-call-settings-heading button {
    display: grid;
    place-items: center;
    width: 32px;
    height: 32px;
    padding: 0;
    border: 0;
    border-radius: 50%;
    color: #536786;
    background: #f6f8fa;
    cursor: pointer;
}
.anna-call-settings button:focus-visible,
.anna-call-settings select:focus-visible {
    outline: 2px solid #0c66ff;
    outline-offset: 2px;
}
.anna-call-settings .anna-call-devices {
    grid-template-columns: minmax(0, 1fr);
}
.anna-call-settings-button {
    position: relative;
    border: 1px solid var(--anna-border);
}
.anna-call-settings-warning,
.anna-call-settings-error {
    color: #a12f36;
}
.anna-call-notice-dot {
    position: absolute;
    top: 4px;
    right: 4px;
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: currentColor;
}
.anna-call-sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip-path: inset(50%);
    white-space: nowrap;
}
.anna-call-devices {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
}
.anna-call-device {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 5px;
}
.anna-call-device label {
    display: flex;
    flex-direction: column;
    gap: 5px;
    min-width: 0;
}
.anna-call-device-label {
    display: flex;
    align-items: center;
    gap: 6px;
    color: #536786;
    font-size: 12px;
}
.anna-call-device select {
    width: 100%;
    min-width: 0;
    min-height: 40px;
    padding: 6px 8px;
    border: 1px solid #e4e9ee;
    border-radius: 8px;
    background: #f9fafb;
    color: #18283f;
    font: inherit;
    font-size: 14px;
    text-overflow: ellipsis;
}
.anna-call-device-name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    color: var(--anna-muted);
    font-size: 12px;
    min-height: 16px;
}
.anna-call-meter {
    position: relative;
    width: 7px;
    height: 32px;
    border-radius: 4px;
    background: var(--anna-border);
    overflow: hidden;
}
.anna-call-meter > div {
    position: absolute;
    bottom: 0;
    width: 100%;
    border-radius: inherit;
    background: linear-gradient(to top, var(--anna-meter-color), #a4e9d1);
    transition: height 80ms linear;
}
.anna-call-level-output .anna-call-meter > div {
    background: linear-gradient(to top, var(--anna-meter-color), #c6ceff);
}
.anna-call-meter::after {
    content: '';
    position: absolute;
    inset: 0;
    background: repeating-linear-gradient(to top, transparent 0 6px, var(--anna-surface) 6px 8px);
}
.anna-call-hint,
.anna-call-duration {
    color: var(--anna-muted);
    font-size: 11px;
}
.anna-call-duration {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 2px;
    min-width: 0;
}
.anna-call-duration > span:first-child {
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.anna-call-clock {
    color: var(--anna-ink);
    font-size: 18px;
    line-height: 24px;
    font-variant-numeric: tabular-nums;
    letter-spacing: 0.5px;
}
.anna-call-settings .anna-call-hint,
.anna-call-settings .anna-call-device-name {
    color: #536786;
}
.anna-composer-actions {
    flex: none;
}
@container anna-composer (max-width: 420px) {
    .anna-composer-footer-idle {
        display: none;
    }
    .anna-call-devices {
        grid-template-columns: minmax(0, 1fr);
        gap: 10px;
    }
}
.anna-end-call {
    color: #a12f36;
    background: #fbefef;
    border: 1px solid #f2d2d5;
    border-radius: 20px;
    padding: 8px 12px;
}
.anna-duration {
    font-size: 12px;
    color: var(--anna-muted);
}
.anna-stage {
    position: relative;
    min-width: 0;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}
.anna-presence {
    flex: 1;
    min-height: 0;
    overflow: auto;
    padding: 32px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    background: radial-gradient(ellipse at 50% 40%, var(--anna-tint) 0, var(--anna-surface) 48%, #fff 100%);
}
.anna-presence-kicker {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
    color: var(--anna-muted);
    margin-bottom: 32px;
}
.anna-portrait {
    width: clamp(160px, 23vw, 330px);
    aspect-ratio: 1;
    border-radius: 50%;
    padding: 9px;
    border: 1px solid var(--anna-border);
    box-shadow: 0 15px 70px #0c66ff14;
    flex: none;
}
.anna-portrait img,
.anna-portrait > span {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 50%;
    background: var(--anna-tint);
    display: grid;
    place-items: center;
    font-size: 70px;
    color: var(--anna-accent);
}
.anna-presence-live .anna-portrait {
    border-color: var(--anna-focus);
    box-shadow:
        0 0 0 10px #0c66ff15,
        0 15px 70px #0c66ff14;
}
.anna-presence-copy {
    text-align: center;
    margin: 30px 0 26px;
}
.anna-presence-copy h2 {
    font-size: 34px;
    font-weight: 400;
    letter-spacing: -1px;
    margin: 10px 0;
}
.anna-presence-copy p {
    font-size: 14px;
    color: var(--anna-muted);
    line-height: 1.5;
}
.anna-quick-views {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    justify-content: center;
}
.anna-quick-views button {
    min-width: 110px;
    display: flex;
    gap: 24px;
    justify-content: space-between;
    background: #ffffff90;
    border: 1px solid var(--anna-border);
    border-radius: 10px;
    padding: 13px 16px;
    color: var(--anna-ink);
    font-size: 13px;
}
.anna-workspace {
    flex: 1;
    min-height: 0;
    min-width: 0;
    flex-direction: column;
    background: white;
}
.anna-workspace-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;
    min-width: 0;
    overflow: hidden;
    isolation: isolate;
}
.anna-pending {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: none;
    padding: 12px 16px;
    background: var(--anna-tint);
    font-size: 13px;
}
.anna-pending span {
    flex: 1;
}
.anna-pending button,
.anna-error button {
    border: 1px solid var(--anna-border);
    background: white;
    border-radius: 6px;
    padding: 6px 10px;
    color: var(--anna-accent);
}
.anna-error {
    color: #a3373c;
    padding: 10px;
    font-size: 13px;
    line-height: 1.5;
}
.anna-empty {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    gap: 14px;
    padding: 28px;
}
.anna-muted {
    color: var(--anna-muted);
    font-size: 13px;
}
.anna-text-button {
    border: 0;
    background: none;
    color: var(--anna-accent);
    padding: 8px;
}
.anna-latest {
    align-self: center;
    border: 1px solid var(--anna-border);
    border-radius: 20px;
    padding: 7px 14px;
    color: var(--anna-accent);
    background: white;
}
.anna-mobile-dock {
    display: none;
}
/* AT-2928: shown while files are dragged over the chat pane. Never a hit target, so the
   drag events keep landing on the pane's own elements underneath. */
.anna-drop-overlay {
    position: absolute;
    inset: 8px;
    z-index: 40;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 2px dashed var(--anna-focus);
    border-radius: 16px;
    background: rgba(240, 246, 255, 0.92);
    pointer-events: none;
}
.anna-drop-overlay-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    padding: 16px 24px;
    color: var(--anna-focus);
    font-size: 15px;
    font-weight: 600;
    text-align: center;
}
@media (max-width: 760px) {
    .anna-header-note {
        display: none;
    }
    .anna-layout {
        display: flex;
        flex-direction: column-reverse;
        position: relative;
    }
    .anna-stage {
        flex: 0 0 30%;
    }
    .anna-conversation {
        flex: 1;
        border-right: 0;
    }
    .anna-presence {
        flex-direction: row;
        gap: 20px;
        padding: 14px 20px;
        justify-content: center;
    }
    .anna-presence-kicker,
    .anna-quick-views {
        display: none;
    }
    .anna-portrait {
        width: 110px;
        padding: 4px;
    }
    .anna-presence-copy {
        margin: 0;
        text-align: left;
    }
    .anna-presence-copy h2 {
        font-size: 23px;
    }
    .anna-presence-copy p {
        font-size: 12px;
        max-width: 180px;
        margin-bottom: 0;
    }
    .anna-presence-copy .anna-eyebrow {
        font-size: 9px;
    }
    .anna-messages {
        padding: 14px 16px;
    }
    .anna-welcome {
        padding: 18px 4px;
    }
    .anna-welcome h1 {
        font-size: 28px;
    }
    .anna-welcome p {
        font-size: 13px;
        margin-bottom: 16px;
    }
    .anna-suggestions {
        flex-direction: row;
        flex-wrap: wrap;
    }
    .anna-suggestions button {
        font-size: 12px;
        padding: 9px 10px;
    }
    .anna-composer {
        margin: 0 14px;
    }
    .anna-composer-shortcut {
        display: none;
    }
    .anna-has-workspace .anna-stage {
        flex: 1;
    }
    .anna-has-workspace .anna-conversation {
        flex: 0 0 auto;
    }
    .anna-has-workspace .anna-conversation .anna-messages {
        display: none;
    }
    .anna-has-workspace .anna-mobile-dock {
        display: flex;
        gap: 10px;
        align-items: center;
        padding: 10px 16px;
        width: 100%;
        background: white;
        border: 0;
        font-size: 13px;
        color: var(--anna-ink);
    }
    .anna-mobile-dock img {
        width: 28px;
        height: 28px;
        border-radius: 50%;
        object-fit: cover;
    }
    .anna-mobile-dock span:last-child {
        margin-left: auto;
    }
    .anna-chat-expanded.anna-has-workspace .anna-conversation {
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 78%;
        z-index: 30;
        border-radius: 18px 18px 0 0;
        box-shadow: 0 -12px 45px #04142f30;
        overflow: hidden;
    }
    .anna-chat-expanded.anna-has-workspace .anna-conversation .anna-messages {
        display: block;
    }
    .app-keyboard-open .anna-shell .anna-stage {
        flex-basis: 0;
    }
    .app-keyboard-open .anna-shell.anna-has-workspace .anna-conversation {
        height: 100%;
    }
}

/* Temporary overlays: the actual task/note DOM and text selection remain untouched. */
.anna-highlight-overlay {
    position: fixed;
    inset: 0;
    pointer-events: none;
    z-index: 10000;
}
.anna-highlight-overlay span {
    position: absolute;
    pointer-events: none;
    border-radius: 3px;
    box-sizing: border-box;
}
.anna-highlight-marker {
    background: rgba(255, 211, 64, 0.38);
    border-bottom: 2px solid #c79100;
}
.anna-highlight-outline {
    outline: 2px solid var(--anna-accent, #0c66ff);
    outline-offset: 2px;
    background: rgba(12, 102, 255, 0.08);
}
.anna-workspace-content {
    position: relative;
}
.anna-highlight-caption {
    position: absolute;
    top: 8px;
    right: 12px;
    max-width: min(340px, calc(100% - 24px));
    z-index: 31;
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 9px 12px;
    border: 1px solid #d9bf6d;
    border-radius: 9px;
    color: #493d18;
    background: #fff8db;
    box-shadow: 0 3px 14px #493d1818;
    font-size: 12px;
}
.anna-highlight-caption span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.anna-highlight-caption button {
    border: 0;
    background: transparent;
    color: inherit;
    padding: 4px;
}

.anna-conversation,
.anna-header,
.anna-browser-surface,
.anna-pending {
    font-family: Roboto, Arial, sans-serif;
    color: var(--anna-ink);
}

/* The workspace subtree stays in the same position in both layouts. */
.anna-zoom-shell [hidden]:not(.anna-workspace-content *) {
    display: none !important;
}
.anna-zoom-shell .anna-layout {
    grid-template-columns: minmax(0, var(--anna-chat-width, 420px)) 6px minmax(0, 1fr);
    position: relative;
}
.anna-zoom-shell .anna-stage {
    position: relative;
    display: flex;
    flex-direction: column;
    min-width: 0;
}
.anna-zoom-shell .anna-workspace {
    display: flex;
    flex: 1;
    min-height: 0;
}
.anna-zoom-shell .anna-workspace-content {
    display: flex;
    flex: 1;
    min-height: 0;
    overflow: hidden;
}
.anna-zoom-shell .anna-workspace-content > * {
    min-width: 0;
}
/* AT-2911: the app beside the chat is framed as the workspace the assistant acts on,
   like a screen in a monitor. The bezel is a gray border of the same thickness on all
   four sides and sits on the outermost box of the workspace column (.anna-stage), so it
   fills the full width and height to the right of the divider. The white space between
   bezel and app is padding of .anna-workspace, horizontal only: the app touches the
   bezel's inner top and bottom edge. That padding is outside .anna-workspace-content,
   the box useWorkspaceViewportOwner measures, so the floating "+", inline fixed overlays
   and popover bounds start at the app's own edge with no compensation of their own. */
.anna-zoom-active {
    --anna-workspace-gutter: clamp(24px, 3.5vw, 48px);
    --anna-workspace-bezel: 6px;
    --anna-workspace-bezel-color: var(--anna-bezel);
    --anna-workspace-radius: 14px;
}
@media (max-width: 1100px) {
    .anna-zoom-active {
        --anna-workspace-gutter: clamp(16px, 2.5vw, 24px);
        --anna-workspace-radius: 12px;
    }
}
@media (min-width: 761px) {
    /* One border width for every edge; the stage clips its content to the inner
       corners (outer radius minus bezel), as on a real display. */
    .anna-zoom-active:not(.anna-chat-only) .anna-stage {
        border: var(--anna-workspace-bezel) solid var(--anna-workspace-bezel-color);
        border-radius: var(--anna-workspace-radius);
        background: #fff;
        transition: border-color 200ms ease;
    }
    .anna-zoom-active:not(.anna-chat-only) .anna-stage > .anna-workspace {
        padding-inline: var(--anna-workspace-gutter);
        background: #fff;
    }
    /* While a tool call changes the workspace, the bezel takes its accent: the chat visibly
       drives it. Thinking and answering keep the default bezel (AT-2926). */
    .anna-zoom-active:not(.anna-chat-only) .anna-stage.anna-stage-working {
        border-color: var(--anna-accent);
    }
    .anna-zoom-active .anna-divider {
        position: relative;
        background: #fff;
    }
    .anna-zoom-active .anna-divider::before {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        width: 1px;
        background: var(--anna-border);
    }
    .anna-zoom-active .anna-divider::after {
        content: '';
        position: absolute;
        top: 50%;
        left: 1px;
        width: 4px;
        height: 40px;
        margin-top: -20px;
        border-radius: 2px;
        background: var(--anna-border);
        transition: background 150ms ease;
    }
    .anna-zoom-active .anna-divider:hover,
    .anna-zoom-active .anna-divider:focus-visible {
        background: #fff;
    }
    .anna-zoom-active .anna-divider:hover::after,
    .anna-zoom-active .anna-divider:focus-visible::after {
        background: var(--anna-focus);
    }
}
.anna-working-label {
    display: none;
}
@media (min-width: 761px) {
    /* Rises from the middle of the bottom bezel like a notch, in the bezel's working
       colour. Bottom rather than top: the app touches the top bezel, and a notch there
       would cover the middle of Alldone's top bar. Never intercepts a click. */
    .anna-working-label {
        position: absolute;
        z-index: 40;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%);
        display: inline-flex;
        align-items: center;
        gap: 6px;
        height: 18px;
        max-width: calc(100% - 2 * var(--anna-workspace-gutter) - 32px);
        padding: 0 10px;
        border-radius: 9px 9px 0 0;
        background: var(--anna-accent);
        color: #fff;
        font-family: Roboto, Arial, sans-serif;
        font-size: 11px !important;
        font-weight: 500;
        line-height: 18px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        pointer-events: none;
    }
    .anna-working-dot {
        flex: none;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #fff;
        animation: anna-working-pulse 1.4s ease-in-out infinite;
    }
}
@keyframes anna-working-pulse {
    0%,
    100% {
        opacity: 1;
    }
    50% {
        opacity: 0.35;
    }
}
@media (prefers-reduced-motion: reduce) {
    .anna-working-dot {
        animation: none;
    }
    .anna-zoom-active .anna-stage {
        transition: none;
    }
}
.anna-zoom-active .anna-workspace-content {
    /* Inline fixed dialogs belong to Alldone, including its navigation. Body
       portals keep browser coordinates and use the measured workspace bounds. */
    transform: translateX(0);
}
.anna-zoom-shell .anna-conversation {
    min-width: 0;
}
.anna-divider {
    cursor: col-resize;
    touch-action: none;
    background: var(--anna-border);
}
.anna-divider:hover,
.anna-divider:focus-visible {
    background: var(--anna-focus);
}
.anna-surface-hidden {
    position: absolute !important;
    inset: 0;
    visibility: hidden;
    pointer-events: none;
}
.anna-fullscreen {
    background: transparent;
}
.anna-fullscreen .anna-layout {
    display: flex;
    flex: 1;
}
.anna-fullscreen .anna-conversation,
.anna-fullscreen .anna-divider {
    display: none;
}
.anna-fullscreen .anna-stage {
    flex: 1;
}
.anna-fullscreen .anna-workspace {
    width: 100%;
}
.anna-date-divider {
    text-align: center;
    color: var(--anna-muted);
    margin: 16px 0;
    font-size: 12px;
}
.anna-browser-surface {
    flex: 1;
    min-height: 0;
    overflow: auto;
    background: var(--anna-surface);
}
.anna-vm-dot {
    width: 6px;
    height: 6px;
    flex: none;
    border-radius: 50%;
    background: var(--anna-accent);
}
.anna-vm-dot-awaiting_user {
    background: #b56b10;
}
.anna-vm-dot-completed,
.anna-vm-dot-cancelled,
.anna-vm-dot-interrupted {
    background: var(--anna-muted);
}
.anna-vm-surface,
.anna-vm-workspace {
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: 0;
    min-width: 0;
    font-family: Roboto, Arial, sans-serif;
    color: var(--anna-ink);
    background: var(--anna-surface);
}
.anna-vm-heading {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 20px;
    border-bottom: 1px solid var(--anna-border);
    background: white;
}
.anna-vm-identity {
    min-width: 0;
}
.anna-vm-identity h2 {
    margin: 6px 0;
    font-size: 18px;
    overflow-wrap: anywhere;
}
.anna-vm-identity .anna-muted {
    font-size: 12px;
    overflow-wrap: anywhere;
}
.anna-vm-status {
    color: var(--anna-accent);
    font-size: 12px;
    font-weight: 500;
}
.anna-vm-paused-hint {
    font-size: 13px;
    margin-bottom: 16px;
}
.anna-vm-task-link {
    color: var(--anna-accent);
    flex-shrink: 0;
    font-size: 12px !important;
}
.anna-vm-activity {
    flex: 1;
    min-height: 0;
    overflow: auto;
    padding: 20px;
    overflow-wrap: anywhere;
}
.anna-vm-terminal {
    background: #20232b;
    color: #ebedf3;
    padding: 20px;
    border-radius: 10px;
    min-height: 240px;
}
.anna-vm-terminal-label {
    color: #a7adbc;
    font-size: 11px;
    margin-bottom: 18px;
}
.anna-vm-terminal pre {
    font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', monospace;
    font-size: 13px;
    line-height: 1.7;
    white-space: pre-wrap;
    overflow-wrap: anywhere;
    margin: 0;
}
.anna-vm-cursor {
    color: #aabcf4;
}
.anna-vm-actions {
    display: flex;
    flex-direction: column;
    margin-top: 16px;
}
@media (max-width: 760px) {
    .anna-vm-heading {
        flex-wrap: wrap;
        padding: 16px;
    }
    .anna-vm-activity {
        padding: 12px;
    }
}
.anna-browser-workspace {
    padding: 16px;
}
.anna-browser-takeover {
    padding: 16px;
}
.anna-browser-heading {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    justify-content: space-between;
}
.anna-browser-heading > div {
    min-width: 0;
    overflow-wrap: anywhere;
}
.anna-browser-heading button {
    flex: none;
}
.anna-browser-workspace button {
    border: 1px solid var(--anna-border);
    background: white;
    border-radius: 7px;
    padding: 8px 12px;
}
.anna-browser-frame {
    margin: 12px 0;
    background: var(--anna-border);
}
.anna-browser-frame img {
    display: block;
    width: 100%;
    height: auto;
}
.anna-browser-controls form {
    display: flex;
    gap: 8px;
    margin-bottom: 8px;
}
.anna-browser-controls input {
    min-width: 0;
    flex: 1;
    padding: 8px;
    border: 1px solid var(--anna-border);
    border-radius: 6px;
    font-size: 16px;
}
.anna-browser-controls > div {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}
.anna-small {
    font-size: 12px;
    color: var(--anna-muted);
    margin-top: 8px;
}
@media (max-width: 760px) {
    .anna-zoom-shell .anna-layout {
        display: flex;
        flex-direction: column;
        position: relative;
    }
    .anna-zoom-shell .anna-divider {
        display: none;
    }
    .anna-zoom-shell .anna-stage,
    .anna-zoom-shell .anna-conversation {
        flex: 1;
        min-height: 0;
    }
    .anna-zoom-active.anna-mobile-chat .anna-stage,
    .anna-zoom-active.anna-mobile-workspace .anna-conversation {
        position: absolute;
        inset: 0;
        visibility: hidden;
        pointer-events: none;
    }
    .anna-fullscreen .anna-stage {
        visibility: visible;
        position: relative;
    }
    .anna-browser-heading {
        flex-wrap: wrap;
    }
}

/* A visual receipt for Anna's saved work, clipped to the Alldone pane. */
.anna-reveal-overlay {
    position: fixed;
    inset: 0;
    z-index: 9998;
    pointer-events: none;
    animation: anna-reveal-lifetime 3.6s ease both;
}
.anna-reveal-ring {
    box-sizing: border-box;
    position: absolute;
    border: 2px solid #438eff;
    border-radius: 12px;
    background: rgba(55, 130, 255, 0.055);
    box-shadow: 0 0 0 4px rgba(55, 130, 255, 0.07);
    animation: anna-reveal-pulse 1.25s ease-in-out 2;
}
.anna-reveal-label {
    box-sizing: border-box;
    position: absolute;
    display: flex;
    align-items: center;
    gap: 7px;
    height: 27px;
    padding: 0 10px 0 6px;
    border: 1px solid #d7e7ff;
    border-radius: 999px;
    color: #175bc5;
    background: rgba(255, 255, 255, 0.96);
    box-shadow: 0 3px 12px #205eaf14;
    font:
        500 12px Roboto,
        Arial,
        sans-serif;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.anna-reveal-check {
    flex-shrink: 0;
    display: grid;
    place-items: center;
    width: 17px;
    height: 17px;
    border-radius: 50%;
    background: #eaf3ff;
}
.anna-reveal-label-text {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
@keyframes anna-reveal-lifetime {
    0% {
        opacity: 0;
    }
    9%,
    82% {
        opacity: 1;
    }
    100% {
        opacity: 0;
    }
}
@keyframes anna-reveal-pulse {
    0%,
    100% {
        box-shadow: 0 0 0 3px #3782ff0c;
        border-color: #438eff;
    }
    48% {
        box-shadow:
            0 0 0 7px #3782ff18,
            0 4px 20px #3782ff0d;
        border-color: #8ab7ff;
    }
}
@media (prefers-reduced-motion: reduce) {
    .anna-message,
    .anna-message-answer,
    .anna-reveal-overlay,
    .anna-reveal-ring {
        animation: none;
    }
    .anna-composer-field,
    .anna-send,
    .anna-call-meter > div {
        transition: none;
    }
}

@keyframes anna-message-arrive {
    from {
        opacity: 0;
        transform: translateY(3px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}
@keyframes anna-answer-arrive {
    from {
        opacity: 0.65;
    }
    to {
        opacity: 1;
    }
}

/* Pane controls belong to the conversation, leaving the workspace full height. */
.anna-pane-toggle {
    display: grid;
    place-items: center;
    flex: none;
    width: 32px;
    height: 36px;
    padding: 0;
    border: 0;
    border-radius: 6px;
    background: transparent;
    color: var(--anna-muted);
}
.anna-pane-toggle:hover {
    background: var(--anna-tint);
    color: var(--anna-accent);
}
.anna-header-picker {
    position: relative;
    flex: 0 1 98px;
    min-width: 0;
}
.anna-header-picker select {
    max-width: 100%;
    font-family: inherit;
    color: var(--anna-ink);
    border: 1px solid var(--anna-border);
    border-radius: 7px;
    background: white;
    cursor: pointer;
}
.anna-header-picker select {
    width: 98px;
    height: 36px;
    padding: 6px 24px 6px 9px;
    font-size: 12px;
    appearance: none;
}
.anna-header-picker > span {
    position: absolute;
    right: 7px;
    top: 10px;
    pointer-events: none;
}
.anna-shell select:focus-visible {
    outline: 2px solid var(--anna-accent);
    outline-offset: 2px;
}
.anna-chat-only .anna-layout {
    grid-template-columns: minmax(0, 1fr);
}
.anna-chat-only .anna-divider {
    display: none;
}
.anna-chat-only .anna-conversation {
    border-right: 0;
}
.anna-chat-only .anna-messages {
    padding-inline: max(24px, calc((100% - 760px) / 2));
}
.anna-chat-only .anna-composer {
    width: calc(100% - 44px);
    max-width: 760px;
    margin-inline: auto;
}
.anna-chat-only .anna-stage {
    position: absolute;
    inset: 0 0 0 auto;
    width: max(0px, calc(100% - var(--anna-chat-width) - 6px));
    visibility: hidden;
    pointer-events: none;
}
.anna-vms {
    position: relative;
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: 0;
    min-width: 0;
    overflow: auto;
    gap: 16px;
    padding: 16px;
    background: var(--anna-surface);
}
.anna-vms .anna-vm-surface {
    flex: none;
    border: 1px solid var(--anna-border);
    border-radius: 12px;
    overflow: hidden;
}
.anna-vms .anna-vm-selected {
    border-color: var(--anna-accent);
}
.anna-vm-surface:focus-visible {
    outline: 2px solid var(--anna-accent);
    outline-offset: 3px;
}
.anna-vms .anna-vm-activity {
    flex: none;
    max-height: min(480px, 60dvh);
}
@media (max-width: 760px) {
    .anna-vms {
        gap: 12px;
        padding: 12px;
    }
    .anna-chat-only .anna-stage {
        width: 100%;
    }
    .anna-header {
        padding: 12px 16px;
        gap: 6px;
    }
    .anna-pane-toggle,
    .anna-header-tasks,
    .anna-header-picker select {
        height: 44px;
    }
    .anna-pane-toggle {
        width: 40px;
    }
    .anna-header-picker > span {
        top: 14px;
    }
    .anna-header-assistant {
        min-height: 44px;
    }
}
@media (max-width: 360px) {
    .anna-header .anna-small-avatar {
        display: none;
    }
}

/* AT-2903: project chip in the composer toolbar and its menu. The menu renders in
   a body portal, outside .anna-shell, so every colour carries a fallback. */
.anna-composer-tools {
    min-width: 0;
}
.anna-project-chip {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
    max-width: 220px;
    height: 32px;
    padding: 0 8px 0 10px;
    border: 1px solid var(--anna-border, #dfe3ea);
    border-radius: 16px;
    background: white;
    color: var(--anna-ink, #04142f);
    font: inherit;
    font-size: 12px;
    cursor: pointer;
}
.anna-project-chip:hover:not(:disabled) {
    background: var(--anna-hover, #eef4ff);
}
.anna-project-chip:disabled {
    cursor: default;
    opacity: 0.55;
}
.anna-project-chip:focus-visible {
    outline: 2px solid var(--anna-accent, #0c66ff);
    outline-offset: 2px;
}
.anna-project-chip-busy .anna-project-chip-name {
    opacity: 0.6;
}
.anna-project-chip-name {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.anna-project-dot {
    flex: none;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: var(--anna-neutral, #b9c1cf);
}
.anna-project-menu {
    box-sizing: border-box;
    font-family: Roboto, Arial, sans-serif;
    display: flex;
    flex-direction: column;
    gap: 6px;
    width: min(320px, calc(100vw - 24px));
    max-height: min(360px, 60dvh);
    padding: 8px;
    border: 1px solid #dfe3ea;
    border-radius: 12px;
    background: white;
    box-shadow: 0 8px 24px #04142f26;
    color: #04142f;
    font-size: 13px;
}
.anna-project-search {
    box-sizing: border-box;
    width: 100%;
    height: 34px;
    padding: 6px 10px;
    border: 1px solid #dfe3ea;
    border-radius: 8px;
    font: inherit;
}
.anna-project-options {
    margin: 0;
    padding: 0;
    list-style: none;
    overflow-y: auto;
    min-height: 0;
}
.anna-project-option {
    display: flex;
    align-items: center;
    gap: 10px;
    width: 100%;
    padding: 8px;
    border: 0;
    border-radius: 8px;
    background: transparent;
    color: inherit;
    font: inherit;
    text-align: left;
    cursor: pointer;
}
.anna-project-option:hover,
.anna-project-option:focus-visible {
    background: #eef4ff;
    outline: none;
}
.anna-project-option-selected {
    color: #0c66ff;
}
.anna-project-option-text {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 0;
}
.anna-project-option-text > * {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.anna-project-option-text > span {
    color: #536786;
    font-size: 11px;
}
.anna-project-menu .anna-muted {
    margin: 4px 8px;
    color: #536786;
}
@container anna-composer (max-width: 420px) {
    .anna-project-chip {
        max-width: 132px;
    }
}
/* Keep a readable part of the name on the narrowest phones: the chip gives up
   its chevron and spacing before it gives up the project name. */
@container anna-composer (max-width: 340px) {
    .anna-composer-toolbar,
    .anna-composer-tools,
    .anna-composer-actions {
        gap: 4px;
    }
    .anna-project-chip {
        flex: 0 1 auto;
        min-width: 72px;
        padding: 0 8px;
        gap: 5px;
    }
    .anna-project-chip > :last-child {
        display: none;
    }
}
/* MCP Apps views (e.g. Judy) opened from the chat: one fills the pane, the others stay mounted. */
.anna-apps {
    position: relative;
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: 0;
    min-width: 0;
    background: var(--anna-surface);
}
.anna-app-surface {
    display: flex;
    flex: 1;
    flex-direction: column;
    min-height: 0;
}
`, "",{"version":3,"sources":["webpack://./components/Anna/anna.css"],"names":[],"mappings":"AAAA;IACI,+BAA+B;IAC/B,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,WAAW;IACX,OAAO;IACP,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,sBAAsB;AAC1B;AACA;;;IAGI,aAAa;AACjB;AACA;IACI,eAAe;AACnB;AACA;IACI,aAAa;IACb,eAAe;AACnB;AACA;;;IAGI,qCAAqC;IACrC,mBAAmB;AACvB;AACA;IACI,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,yDAAyD;IACzD,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,kBAAkB;IAClB,2CAA2C;IAC3C,gBAAgB;AACpB;AACA;;IAEI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,YAAY;AAChB;AACA;IACI,0CAA0C;AAC9C;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;IACZ,cAAc;IACd,SAAS;IACT,kBAAkB;IAClB,uBAAuB;IACvB,wBAAwB;AAC5B;AACA;IACI,4BAA4B;IAC5B,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,UAAU;AACd;AACA;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;AAChC;AACA;IACI,wBAAwB;IACxB,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,SAAS;IACT,gBAAgB;IAChB,sBAAsB;IACtB,0BAA0B;AAC9B;AACA;IACI,sBAAsB;IACtB,qBAAqB;IACrB,0BAA0B;AAC9B;AACA;IACI,aAAa;IACb,wDAAwD;IACxD,OAAO;IACP,aAAa;AACjB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,YAAY;IACZ,0CAA0C;IAC1C,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,cAAc;IACd,YAAY;IACZ,QAAQ;IACR,mBAAmB;IACnB,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,MAAM;IACN,UAAU;IACV,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,OAAO;IACP,YAAY;IACZ,mBAAmB;IACnB,SAAS;AACb;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,4BAA4B;IAC5B,gBAAgB;IAChB,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,wBAAwB;IACxB,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,8BAA8B;AAClC;AACA;IACI,aAAa;IACb,YAAY;IACZ,qBAAqB;IACrB,cAAc;IACd,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,SAAS;AACb;AACA;IACI,OAAO;IACP,uBAAuB;AAC3B;AACA;IACI,UAAU;IACV,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,OAAO;IACP,YAAY;IACZ,qBAAqB;IACrB,QAAQ;IACR,wBAAwB;IACxB,qBAAqB;AACzB;AACA;IACI,qBAAqB;AACzB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,QAAQ;AACZ;AACA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,UAAU;AACd;AACA;IACI,aAAa;IACb,eAAe;IACf,YAAY;IACZ,QAAQ;AACZ;AACA;;IAEI,oBAAoB;IACpB,mBAAmB;IACnB,sBAAsB;IACtB;;2DAEuD;IACvD,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,oBAAoB;IACpB,4BAA4B;IAC5B,eAAe;IACf,iBAAiB;IACjB,mBAAmB;AACvB;AACA;0EAC0E;AAC1E;IACI,cAAc;IACd,cAAc;IACd,uBAAuB;AAC3B;AACA;IACI,QAAQ;IACR,aAAa;IACb,wBAAwB;IACxB,yBAAyB;AAC7B;AACA;IACI,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;;IAEI,wBAAwB;AAC5B;AACA,yEAAyE;AACzE;IACI,oBAAoB;IACpB,gBAAgB;IAChB,4BAA4B;IAC5B,qBAAqB;AACzB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,yBAAyB;AAC7B;AACA;IACI;0FACsF;IACtF,kBAAkB;IAClB,gBAAgB;IAChB,OAAO;IACP,aAAa;IACb,uBAAuB;IACvB,4BAA4B;IAC5B,uBAAuB;IACvB,2EAA2E;IAC3E,qBAAqB;IACrB,wBAAwB;IACxB,qBAAqB;AACzB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,4CAA4C;AAChD;AACA;IACI,oCAAoC;IACpC,oBAAoB;AACxB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,eAAe;IACf,qBAAqB;IACrB,yBAAyB;IACzB,wBAAwB;AAC5B;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,sBAAsB;IACtB,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,wBAAwB;IACxB,eAAe;IACf,iBAAiB;IACjB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,uBAAuB;AAC3B;AACA;IACI,oCAAoC;IACpC,+BAA+B;IAC/B,kBAAkB;IAClB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,kDAAkD;AACtD;AACA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,kBAAkB;IAClB,oCAAoC;AACxC;AACA;;yDAEyD;AACzD;IACI,YAAY;AAChB;AACA;IACI,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,wBAAwB;AAC5B;AACA;IACI,aAAa;IACb,UAAU;IACV,WAAW;IACX,YAAY;AAChB;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,eAAe;IACf,wBAAwB;IACxB,eAAe;AACnB;AACA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,UAAU;IACV,cAAc;IACd,oDAAoD;IACpD,sCAAsC;AAC1C;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,0BAA0B;AAC9B;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,uBAAuB;IACvB,oCAAoC;IACpC,+BAA+B;IAC/B,mBAAmB;IACnB;;6BAEyB;AAC7B;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;AACA;IACI,YAAY;IACZ,WAAW;AACf;AACA;;IAEI,uBAAuB;IACvB,SAAS;IACT,iCAAiC;IACjC,0BAA0B;IAC1B,4BAA4B;AAChC;AACA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,8BAA8B;AAClC;AACA;IACI,iBAAiB;AACrB;AACA;IACI,8BAA8B;IAC9B,kFAAkF;IAClF,MAAM;IACN,oBAAoB;IACpB,qBAAqB;AACzB;AACA;IACI,+BAA+B;IAC/B,uCAAuC;AAC3C;AACA;IACI,aAAa;AACjB;AACA;;;IAGI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;AACA;IACI,8BAA8B;AAClC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,UAAU;AACd;AACA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,8BAA8B;IAC9B,YAAY;IACZ;;0BAEsB;AAC1B;AACA;IACI,+BAA+B;AACnC;AACA;IACI,WAAW;IACX,YAAY;IACZ,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,uBAAuB;IACvB,wBAAwB;AAC5B;AACA;IACI,6BAA6B;AACjC;AACA;;IAEI,cAAc;IACd,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,eAAe;IACf,wBAAwB;IACxB,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;IACI,UAAU;AACd;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,uBAAuB;IACvB,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,QAAQ;AACZ;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,gBAAgB;IAChB,YAAY;AAChB;AACA;IACI,aAAa;IACb,SAAS;IACT,UAAU;AACd;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,oCAAoC;IACpC,mBAAmB;IACnB,+BAA+B;IAC/B,cAAc;IACd,2BAA2B;AAC/B;AACA;IACI,cAAc;IACd,2BAA2B;AAC/B;AACA;IACI,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,aAAa;IACb,cAAc;IACd,yBAAyB;IACzB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,gCAAgC;IAChC;;;;kBAIc;AAClB;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,QAAQ;AACZ;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,eAAe;AACnB;AACA;;IAEI,0BAA0B;IAC1B,mBAAmB;AACvB;AACA;IACI,qCAAqC;AACzC;AACA;IACI,kBAAkB;IAClB,oCAAoC;AACxC;AACA;;IAEI,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,wBAAwB;AAC5B;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,gDAAgD;IAChD,SAAS;AACb;AACA;IACI,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;AAChB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,eAAe;IACf,uBAAuB;AAC3B;AACA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,wBAAwB;IACxB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,8BAA8B;IAC9B,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,sBAAsB;IACtB,qEAAqE;IACrE,8BAA8B;AAClC;AACA;IACI,qEAAqE;AACzE;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,6FAA6F;AACjG;AACA;;IAEI,wBAAwB;IACxB,eAAe;AACnB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;IACrB,QAAQ;IACR,YAAY;AAChB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,sBAAsB;IACtB,eAAe;IACf,iBAAiB;IACjB,kCAAkC;IAClC,qBAAqB;AACzB;AACA;;IAEI,cAAc;AAClB;AACA;IACI,UAAU;AACd;AACA;IACI;QACI,aAAa;IACjB;IACA;QACI,qCAAqC;QACrC,SAAS;IACb;AACJ;AACA;IACI,cAAc;IACd,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,eAAe;IACf,wBAAwB;AAC5B;AACA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI,OAAO;IACP,aAAa;IACb,cAAc;IACd,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,uGAAuG;AAC3G;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,wBAAwB;IACxB,mBAAmB;AACvB;AACA;IACI,gCAAgC;IAChC,eAAe;IACf,kBAAkB;IAClB,YAAY;IACZ,oCAAoC;IACpC,iCAAiC;IACjC,UAAU;AACd;AACA;;IAEI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,4BAA4B;IAC5B,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,yBAAyB;AAC7B;AACA;IACI,+BAA+B;IAC/B;;6BAEyB;AAC7B;AACA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,cAAc;AAClB;AACA;IACI,eAAe;IACf,wBAAwB;IACxB,gBAAgB;AACpB;AACA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,uBAAuB;AAC3B;AACA;IACI,gBAAgB;IAChB,aAAa;IACb,SAAS;IACT,8BAA8B;IAC9B,qBAAqB;IACrB,oCAAoC;IACpC,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;AACnB;AACA;IACI,OAAO;IACP,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,iBAAiB;AACrB;AACA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,UAAU;IACV,kBAAkB;IAClB,4BAA4B;IAC5B,eAAe;AACnB;AACA;IACI,OAAO;AACX;AACA;;IAEI,oCAAoC;IACpC,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,yBAAyB;AAC7B;AACA;IACI,cAAc;IACd,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,OAAO;IACP,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,sBAAsB;IACtB,SAAS;IACT,aAAa;AACjB;AACA;IACI,wBAAwB;IACxB,eAAe;AACnB;AACA;IACI,SAAS;IACT,gBAAgB;IAChB,yBAAyB;IACzB,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,oCAAoC;IACpC,mBAAmB;IACnB,iBAAiB;IACjB,yBAAyB;IACzB,iBAAiB;AACrB;AACA;IACI,aAAa;AACjB;AACA;oEACoE;AACpE;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,oCAAoC;IACpC,mBAAmB;IACnB,qCAAqC;IACrC,oBAAoB;AACxB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,wBAAwB;IACxB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;AACA;IACI;QACI,aAAa;IACjB;IACA;QACI,aAAa;QACb,8BAA8B;QAC9B,kBAAkB;IACtB;IACA;QACI,aAAa;IACjB;IACA;QACI,OAAO;QACP,eAAe;IACnB;IACA;QACI,mBAAmB;QACnB,SAAS;QACT,kBAAkB;QAClB,uBAAuB;IAC3B;IACA;;QAEI,aAAa;IACjB;IACA;QACI,YAAY;QACZ,YAAY;IAChB;IACA;QACI,SAAS;QACT,gBAAgB;IACpB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,gBAAgB;QAChB,gBAAgB;IACpB;IACA;QACI,cAAc;IAClB;IACA;QACI,kBAAkB;IACtB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;QACf,mBAAmB;IACvB;IACA;QACI,mBAAmB;QACnB,eAAe;IACnB;IACA;QACI,eAAe;QACf,iBAAiB;IACrB;IACA;QACI,cAAc;IAClB;IACA;QACI,aAAa;IACjB;IACA;QACI,OAAO;IACX;IACA;QACI,cAAc;IAClB;IACA;QACI,aAAa;IACjB;IACA;QACI,aAAa;QACb,SAAS;QACT,mBAAmB;QACnB,kBAAkB;QAClB,WAAW;QACX,iBAAiB;QACjB,SAAS;QACT,eAAe;QACf,sBAAsB;IAC1B;IACA;QACI,WAAW;QACX,YAAY;QACZ,kBAAkB;QAClB,iBAAiB;IACrB;IACA;QACI,iBAAiB;IACrB;IACA;QACI,kBAAkB;QAClB,SAAS;QACT,WAAW;QACX,WAAW;QACX,WAAW;QACX,4BAA4B;QAC5B,kCAAkC;QAClC,gBAAgB;IACpB;IACA;QACI,cAAc;IAClB;IACA;QACI,aAAa;IACjB;IACA;QACI,YAAY;IAChB;AACJ;;AAEA,sFAAsF;AACtF;IACI,eAAe;IACf,QAAQ;IACR,oBAAoB;IACpB,cAAc;AAClB;AACA;IACI,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,sBAAsB;AAC1B;AACA;IACI,oCAAoC;IACpC,gCAAgC;AACpC;AACA;IACI,8CAA8C;IAC9C,mBAAmB;IACnB,oCAAoC;AACxC;AACA;IACI,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,wCAAwC;IACxC,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,cAAc;IACd,mBAAmB;IACnB,gCAAgC;IAChC,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,SAAS;IACT,uBAAuB;IACvB,cAAc;IACd,YAAY;AAChB;;AAEA;;;;IAII,sCAAsC;IACtC,sBAAsB;AAC1B;;AAEA,sEAAsE;AACtE;IACI,wBAAwB;AAC5B;AACA;IACI,kFAAkF;IAClF,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;AACA;IACI,aAAa;IACb,OAAO;IACP,aAAa;AACjB;AACA;IACI,aAAa;IACb,OAAO;IACP,aAAa;IACb,gBAAgB;AACpB;AACA;IACI,YAAY;AAChB;AACA;;;;;;;sFAOsF;AACtF;IACI,iDAAiD;IACjD,2BAA2B;IAC3B,+CAA+C;IAC/C,6BAA6B;AACjC;AACA;IACI;QACI,iDAAiD;QACjD,6BAA6B;IACjC;AACJ;AACA;IACI;kEAC8D;IAC9D;QACI,2EAA2E;QAC3E,2CAA2C;QAC3C,gBAAgB;QAChB,mCAAmC;IACvC;IACA;QACI,4CAA4C;QAC5C,gBAAgB;IACpB;IACA;4EACwE;IACxE;QACI,gCAAgC;IACpC;IACA;QACI,kBAAkB;QAClB,gBAAgB;IACpB;IACA;QACI,WAAW;QACX,kBAAkB;QAClB,MAAM;QACN,SAAS;QACT,OAAO;QACP,UAAU;QACV,8BAA8B;IAClC;IACA;QACI,WAAW;QACX,kBAAkB;QAClB,QAAQ;QACR,SAAS;QACT,UAAU;QACV,YAAY;QACZ,iBAAiB;QACjB,kBAAkB;QAClB,8BAA8B;QAC9B,iCAAiC;IACrC;IACA;;QAEI,gBAAgB;IACpB;IACA;;QAEI,6BAA6B;IACjC;AACJ;AACA;IACI,aAAa;AACjB;AACA;IACI;;+EAE2E;IAC3E;QACI,kBAAkB;QAClB,WAAW;QACX,SAAS;QACT,SAAS;QACT,2BAA2B;QAC3B,oBAAoB;QACpB,mBAAmB;QACnB,QAAQ;QACR,YAAY;QACZ,+DAA+D;QAC/D,eAAe;QACf,0BAA0B;QAC1B,8BAA8B;QAC9B,WAAW;QACX,sCAAsC;QACtC,0BAA0B;QAC1B,gBAAgB;QAChB,iBAAiB;QACjB,mBAAmB;QACnB,gBAAgB;QAChB,uBAAuB;QACvB,oBAAoB;IACxB;IACA;QACI,UAAU;QACV,UAAU;QACV,WAAW;QACX,kBAAkB;QAClB,gBAAgB;QAChB,uDAAuD;IAC3D;AACJ;AACA;IACI;;QAEI,UAAU;IACd;IACA;QACI,aAAa;IACjB;AACJ;AACA;IACI;QACI,eAAe;IACnB;IACA;QACI,gBAAgB;IACpB;AACJ;AACA;IACI;gFAC4E;IAC5E,wBAAwB;AAC5B;AACA;IACI,YAAY;AAChB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,8BAA8B;AAClC;AACA;;IAEI,6BAA6B;AACjC;AACA;IACI,6BAA6B;IAC7B,QAAQ;IACR,kBAAkB;IAClB,oBAAoB;AACxB;AACA;IACI,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,OAAO;AACX;AACA;;IAEI,aAAa;AACjB;AACA;IACI,OAAO;AACX;AACA;IACI,WAAW;AACf;AACA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,cAAc;IACd,eAAe;AACnB;AACA;IACI,OAAO;IACP,aAAa;IACb,cAAc;IACd,+BAA+B;AACnC;AACA;IACI,UAAU;IACV,WAAW;IACX,UAAU;IACV,kBAAkB;IAClB,8BAA8B;AAClC;AACA;IACI,mBAAmB;AACvB;AACA;;;IAGI,6BAA6B;AACjC;AACA;;IAEI,aAAa;IACb,OAAO;IACP,sBAAsB;IACtB,aAAa;IACb,YAAY;IACZ,sCAAsC;IACtC,sBAAsB;IACtB,+BAA+B;AACnC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,SAAS;IACT,aAAa;IACb,2CAA2C;IAC3C,iBAAiB;AACrB;AACA;IACI,YAAY;AAChB;AACA;IACI,aAAa;IACb,eAAe;IACf,uBAAuB;AAC3B;AACA;IACI,eAAe;IACf,uBAAuB;AAC3B;AACA;IACI,yBAAyB;IACzB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,yBAAyB;IACzB,cAAc;IACd,0BAA0B;AAC9B;AACA;IACI,OAAO;IACP,aAAa;IACb,cAAc;IACd,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,mBAAmB;IACnB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,eAAe;IACf,mBAAmB;AACvB;AACA;IACI,qEAAqE;IACrE,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,uBAAuB;IACvB,SAAS;AACb;AACA;IACI,cAAc;AAClB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;AACA;IACI;QACI,eAAe;QACf,aAAa;IACjB;IACA;QACI,aAAa;IACjB;AACJ;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;AACjB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,8BAA8B;AAClC;AACA;IACI,YAAY;IACZ,uBAAuB;AAC3B;AACA;IACI,UAAU;AACd;AACA;IACI,oCAAoC;IACpC,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;AACA;IACI,cAAc;IACd,8BAA8B;AAClC;AACA;IACI,cAAc;IACd,WAAW;IACX,YAAY;AAChB;AACA;IACI,aAAa;IACb,QAAQ;IACR,kBAAkB;AACtB;AACA;IACI,YAAY;IACZ,OAAO;IACP,YAAY;IACZ,oCAAoC;IACpC,kBAAkB;IAClB,eAAe;AACnB;AACA;IACI,aAAa;IACb,eAAe;IACf,QAAQ;AACZ;AACA;IACI,eAAe;IACf,wBAAwB;IACxB,eAAe;AACnB;AACA;IACI;QACI,aAAa;QACb,sBAAsB;QACtB,kBAAkB;IACtB;IACA;QACI,aAAa;IACjB;IACA;;QAEI,OAAO;QACP,aAAa;IACjB;IACA;;QAEI,kBAAkB;QAClB,QAAQ;QACR,kBAAkB;QAClB,oBAAoB;IACxB;IACA;QACI,mBAAmB;QACnB,kBAAkB;IACtB;IACA;QACI,eAAe;IACnB;AACJ;;AAEA,yEAAyE;AACzE;IACI,eAAe;IACf,QAAQ;IACR,aAAa;IACb,oBAAoB;IACpB,8CAA8C;AAClD;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;IACnB,qCAAqC;IACrC,8CAA8C;IAC9C,gDAAgD;AACpD;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,qBAAqB;IACrB,yBAAyB;IACzB,oBAAoB;IACpB,cAAc;IACd,qCAAqC;IACrC,gCAAgC;IAChC;;;kBAGc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;AACA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;AACvB;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI;QACI,UAAU;IACd;IACA;;QAEI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;AACA;IACI;;QAEI,+BAA+B;QAC/B,qBAAqB;IACzB;IACA;QACI;;gCAEwB;QACxB,qBAAqB;IACzB;AACJ;AACA;IACI;;;;QAII,eAAe;IACnB;IACA;;;QAGI,gBAAgB;IACpB;AACJ;;AAEA;IACI;QACI,UAAU;QACV,0BAA0B;IAC9B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;AACA;IACI;QACI,aAAa;IACjB;IACA;QACI,UAAU;IACd;AACJ;;AAEA,iFAAiF;AACjF;IACI,aAAa;IACb,mBAAmB;IACnB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,UAAU;IACV,SAAS;IACT,kBAAkB;IAClB,uBAAuB;IACvB,wBAAwB;AAC5B;AACA;IACI,4BAA4B;IAC5B,yBAAyB;AAC7B;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,YAAY;AAChB;AACA;IACI,eAAe;IACf,oBAAoB;IACpB,sBAAsB;IACtB,oCAAoC;IACpC,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,oBAAoB;AACxB;AACA;IACI,qCAAqC;IACrC,mBAAmB;AACvB;AACA;IACI,qCAAqC;AACzC;AACA;IACI,aAAa;AACjB;AACA;IACI,eAAe;AACnB;AACA;IACI,mDAAmD;AACvD;AACA;IACI,wBAAwB;IACxB,gBAAgB;IAChB,mBAAmB;AACvB;AACA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,0DAA0D;IAC1D,kBAAkB;IAClB,oBAAoB;AACxB;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,OAAO;IACP,sBAAsB;IACtB,aAAa;IACb,YAAY;IACZ,cAAc;IACd,SAAS;IACT,aAAa;IACb,+BAA+B;AACnC;AACA;IACI,UAAU;IACV,oCAAoC;IACpC,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,gCAAgC;AACpC;AACA;IACI,qCAAqC;IACrC,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,6BAA6B;AACjC;AACA;IACI;QACI,SAAS;QACT,aAAa;IACjB;IACA;QACI,WAAW;IACf;IACA;QACI,kBAAkB;QAClB,QAAQ;IACZ;IACA;;;QAGI,YAAY;IAChB;IACA;QACI,WAAW;IACf;IACA;QACI,SAAS;IACb;IACA;QACI,gBAAgB;IACpB;AACJ;AACA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;4EAC4E;AAC5E;IACI,YAAY;AAChB;AACA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,qBAAqB;IACrB,6CAA6C;IAC7C,mBAAmB;IACnB,iBAAiB;IACjB,+BAA+B;IAC/B,aAAa;IACb,eAAe;IACf,eAAe;AACnB;AACA;IACI,sCAAsC;AAC1C;AACA;IACI,eAAe;IACf,aAAa;AACjB;AACA;IACI,8CAA8C;IAC9C,mBAAmB;AACvB;AACA;IACI,YAAY;AAChB;AACA;IACI,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,wCAAwC;AAC5C;AACA;IACI,sBAAsB;IACtB,sCAAsC;IACtC,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,qCAAqC;IACrC,6BAA6B;IAC7B,YAAY;IACZ,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,gCAAgC;IAChC,cAAc;IACd,eAAe;AACnB;AACA;IACI,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;AACjB;AACA;IACI,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,WAAW;IACX,YAAY;IACZ,SAAS;IACT,kBAAkB;IAClB,uBAAuB;IACvB,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,eAAe;AACnB;AACA;;IAEI,mBAAmB;IACnB,aAAa;AACjB;AACA;IACI,cAAc;AAClB;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,OAAO;IACP,YAAY;AAChB;AACA;IACI,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,cAAc;IACd,eAAe;AACnB;AACA;IACI,eAAe;IACf,cAAc;AAClB;AACA;IACI;QACI,gBAAgB;IACpB;AACJ;AACA;iEACiE;AACjE;IACI;;;QAGI,QAAQ;IACZ;IACA;QACI,cAAc;QACd,eAAe;QACf,cAAc;QACd,QAAQ;IACZ;IACA;QACI,aAAa;IACjB;AACJ;AACA,kGAAkG;AAClG;IACI,kBAAkB;IAClB,aAAa;IACb,OAAO;IACP,sBAAsB;IACtB,aAAa;IACb,YAAY;IACZ,+BAA+B;AACnC;AACA;IACI,aAAa;IACb,OAAO;IACP,sBAAsB;IACtB,aAAa;AACjB","sourcesContent":[".anna-shell {\n    background: var(--anna-surface);\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    width: 100%;\n    flex: 1;\n    min-height: 0;\n    overflow: hidden;\n}\n.anna-shell *:not(.anna-workspace-content, .anna-workspace-content *) {\n    box-sizing: border-box;\n}\n.anna-shell button:not(.anna-workspace-content *),\n.anna-shell textarea:not(.anna-workspace-content *),\n.anna-shell a:not(.anna-workspace-content *) {\n    font: inherit;\n}\n.anna-shell button:not(.anna-workspace-content *) {\n    cursor: pointer;\n}\n.anna-shell button:not(.anna-workspace-content *):disabled {\n    opacity: 0.45;\n    cursor: default;\n}\n.anna-shell button:not(.anna-workspace-content *):focus-visible,\n.anna-shell a:not(.anna-workspace-content *):focus-visible,\n.anna-shell textarea:not(.anna-workspace-content *):focus-visible {\n    outline: 2px solid var(--anna-accent);\n    outline-offset: 3px;\n}\n.anna-header {\n    min-height: 72px;\n    flex: none;\n    display: grid;\n    grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);\n    align-items: center;\n    gap: 8px;\n    flex-wrap: nowrap;\n    padding: 16px 24px;\n    border-bottom: 1px solid var(--anna-border);\n    background: #fff;\n}\n.anna-header-left,\n.anna-header-right {\n    display: flex;\n    align-items: center;\n    gap: inherit;\n    min-width: 0;\n}\n.anna-header-sidebar {\n    grid-template-columns: minmax(0, 1fr) auto;\n}\n.anna-header-right {\n    justify-content: flex-end;\n}\n.anna-header-tasks {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    min-width: 44px;\n    height: 36px;\n    padding: 0 4px;\n    border: 0;\n    border-radius: 6px;\n    background: transparent;\n    color: var(--anna-muted);\n}\n.anna-header-tasks:hover {\n    background: var(--anna-tint);\n    color: var(--anna-accent);\n}\n.anna-task-icon {\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 28px;\n    height: 28px;\n    flex: none;\n}\n.anna-brand {\n    color: var(--anna-ink);\n    font-size: 14px;\n    font-weight: 500;\n    line-height: 18px;\n    display: block;\n    overflow: hidden;\n    white-space: normal;\n    overflow-wrap: anywhere;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n}\n.anna-header-note {\n    color: var(--anna-muted);\n    font-size: 13px;\n}\n.anna-search {\n    margin-left: auto;\n    border: 0;\n    background: none;\n    color: var(--anna-ink);\n    font-size: 13px !important;\n}\n.anna-workspace-link {\n    color: var(--anna-ink);\n    text-decoration: none;\n    font-size: 13px !important;\n}\n.anna-layout {\n    display: grid;\n    grid-template-columns: minmax(330px, 38%) minmax(0, 1fr);\n    flex: 1;\n    min-height: 0;\n}\n.anna-conversation {\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n    min-width: 0;\n    border-right: 1px solid var(--anna-border);\n    background: #fff;\n    position: relative;\n}\n.anna-header-assistant {\n    display: flex;\n    flex: 0 1 auto;\n    min-width: 0;\n    gap: 8px;\n    align-items: center;\n    padding: 0;\n    border: 0;\n    border-radius: 8px;\n    background: none;\n    color: var(--anna-ink);\n    text-align: left;\n}\n.anna-header-assistant:hover .anna-brand {\n    color: var(--anna-accent);\n}\n.anna-open-tasks-badge {\n    position: absolute;\n    top: 0;\n    left: 14px;\n    display: inline-flex;\n}\n.anna-header-details {\n    display: flex;\n    flex: 1;\n    min-width: 0;\n    align-items: center;\n    gap: 16px;\n}\n.anna-header-identity {\n    min-width: 0;\n    max-width: 360px;\n    flex: 0 1 auto;\n}\n.anna-small-avatar {\n    width: 30px;\n    height: 30px;\n    flex: none;\n    border-radius: 50%;\n    background: var(--anna-tint);\n    overflow: hidden;\n    display: grid;\n    place-items: center;\n}\n.anna-small-avatar img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n}\n.anna-header-identity > span {\n    display: block;\n    max-width: 220px;\n    margin-top: 3px;\n    font-size: 12px;\n    color: var(--anna-muted);\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n}\n.anna-shell i:not(.anna-workspace-content *) {\n    display: inline-block;\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: var(--anna-accent);\n}\n.anna-context-notice {\n    display: flex;\n    min-width: 0;\n    align-items: baseline;\n    margin: 16px 0;\n    color: var(--anna-muted);\n    font-size: 12px;\n    line-height: 1.5;\n    gap: 12px;\n}\n.anna-context-notice span {\n    flex: 1;\n    overflow-wrap: anywhere;\n}\n.anna-context-notice time {\n    flex: none;\n    font-size: 10px;\n    white-space: nowrap;\n}\n.anna-activity-notice a {\n    display: flex;\n    flex: 1;\n    min-width: 0;\n    align-items: baseline;\n    gap: 6px;\n    color: var(--anna-muted);\n    text-decoration: none;\n}\n.anna-activity-notice a:hover {\n    text-decoration: none;\n}\n.anna-activity-content {\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n    gap: 3px;\n}\n.anna-activity-title {\n    overflow: hidden;\n    color: var(--anna-ink);\n    font-weight: 500;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.anna-activity-content > span {\n    flex: none;\n}\n.anna-activity-actions {\n    display: flex;\n    flex-wrap: wrap;\n    min-width: 0;\n    gap: 4px;\n}\n.anna-activity-action,\n.anna-activity-link {\n    display: inline-flex;\n    align-items: center;\n    box-sizing: border-box;\n    /* A chip never gets wider than its row (AT-2918): \"Mit Ziel verknüpft: <long goal name>\"\n       otherwise pushed the row past a narrow chat pane. One line, ellipsis, full text in the\n       title; the whole row stays the link to the object. */\n    max-width: 100%;\n    min-width: 0;\n    overflow: hidden;\n    padding: 0 6px;\n    border-radius: 999px;\n    background: var(--anna-tint);\n    font-size: 10px;\n    line-height: 16px;\n    white-space: nowrap;\n}\n/* text-overflow needs a block container, not a flex container, so the action chip (text only)\n   is a block; it still sits in the wrapping .anna-activity-actions row. */\n.anna-activity-actions > .anna-activity-action {\n    display: block;\n    flex: 0 1 auto;\n    text-overflow: ellipsis;\n}\n.anna-activity-link {\n    gap: 3px;\n    margin: 0 2px;\n    vertical-align: baseline;\n    color: var(--anna-accent);\n}\n.anna-activity-link > .anna-activity-link-label {\n    flex: 0 1 auto;\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n.anna-activity-preview,\n.anna-activity-meta {\n    color: var(--anna-muted);\n}\n/* A preview hints at the message; the object holds the rest (AT-2906). */\n.anna-activity-preview {\n    display: -webkit-box;\n    overflow: hidden;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 2;\n}\n.anna-activity-meta {\n    overflow: hidden;\n    font-size: 10px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.anna-activity-notice a > :last-child {\n    flex-shrink: 0;\n    color: var(--anna-accent);\n}\n.anna-messages {\n    /* The conversation scrolls vertically only (AT-2917). Wide content owns its own\n       horizontal scroller (tables) or wraps; a sideways swipe must never move the chat. */\n    overflow-x: hidden;\n    overflow-y: auto;\n    flex: 1;\n    min-height: 0;\n    padding: 16px 24px 24px;\n    overscroll-behavior: contain;\n    overflow-wrap: anywhere;\n    /* The follow controller owns anchoring. Browser anchoring would race it. */\n    overflow-anchor: none;\n    scrollbar-gutter: stable;\n    scroll-behavior: auto;\n}\n.anna-message-timeline {\n    display: flow-root;\n}\n.anna-message-answer {\n    animation: anna-answer-arrive 160ms ease-out;\n}\n.anna-messages:focus-visible {\n    outline: 2px solid var(--anna-focus);\n    outline-offset: -2px;\n}\n.anna-welcome {\n    padding: 48px 4px 28px;\n}\n.anna-eyebrow {\n    font-size: 11px;\n    letter-spacing: 1.5px;\n    text-transform: uppercase;\n    color: var(--anna-muted);\n}\n.anna-welcome h1 {\n    font-size: 34px;\n    font-weight: 400;\n    letter-spacing: -1.1px;\n    line-height: 1.2;\n    margin: 16px 0;\n}\n.anna-welcome p {\n    color: var(--anna-muted);\n    font-size: 15px;\n    line-height: 1.65;\n    margin: 0 0 30px;\n}\n.anna-suggestions {\n    display: flex;\n    flex-direction: column;\n    gap: 9px;\n    align-items: flex-start;\n}\n.anna-suggestions button {\n    border: 1px solid var(--anna-border);\n    background: var(--anna-surface);\n    border-radius: 9px;\n    color: var(--anna-ink);\n    padding: 11px 14px;\n    font-size: 13px;\n    text-align: left;\n}\n.anna-message {\n    border-radius: 12px;\n    margin: 0 0 24px;\n    padding: 10px 0;\n    min-width: 0;\n    animation: anna-message-arrive 180ms ease-out both;\n}\n.anna-message-user {\n    margin-left: 32px;\n    background: var(--anna-neutral);\n    padding: 14px 16px;\n    border: 1px solid var(--anna-border);\n}\n/* AT-2922: written while the previous answer was still running; sent once it is complete.\n   AT-2927: only the message fades. The queued note stays at full strength so it reads as the\n   state of the message rather than as more faded text. */\n.anna-message-queued > :not(.anna-message-queue-note) {\n    opacity: 0.6;\n}\n.anna-message-queue-note {\n    min-width: 0;\n    margin: -2px 0 10px;\n}\n.anna-message-author {\n    display: flex;\n    gap: 6px;\n    align-items: center;\n    font-size: 12px;\n    font-weight: 500;\n    margin-bottom: 8px;\n    color: var(--anna-muted);\n}\n.anna-message-avatar {\n    display: flex;\n    flex: none;\n    width: 20px;\n    height: 20px;\n}\n.anna-message-author-name {\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.anna-message-text {\n    white-space: pre-wrap;\n    overflow-wrap: anywhere;\n    font-size: 14px;\n    line-height: 1.5;\n}\n.anna-message-status {\n    display: block;\n    margin-top: 8px;\n    color: var(--anna-muted);\n    font-size: 11px;\n}\n.anna-message-author time {\n    margin-left: auto;\n    flex-shrink: 0;\n    font-size: 10px;\n    font-weight: 400;\n}\n.anna-composer {\n    flex: none;\n    margin: 0 22px;\n    padding: 8px 0 max(8px, env(safe-area-inset-bottom));\n    container: anna-composer / inline-size;\n}\n.anna-composer-slot {\n    position: relative;\n}\n.anna-composer-slot-connecting .anna-composer-field {\n    visibility: hidden;\n}\n.anna-composer-connecting {\n    position: absolute;\n    inset: 0;\n    display: flex;\n    border-radius: 20px;\n}\n.anna-composer-cancel {\n    position: absolute;\n    bottom: 2px;\n    right: 8px;\n    font-size: 11px !important;\n}\n.anna-composer-field {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    padding: 14px 12px 10px;\n    border: 1px solid var(--anna-border);\n    background: var(--anna-surface);\n    border-radius: 20px;\n    transition:\n        border-color 150ms ease,\n        box-shadow 150ms ease;\n}\n.anna-composer-draft {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    min-width: 0;\n}\n.anna-composer-slot-voice .anna-composer-draft {\n    visibility: hidden;\n    pointer-events: none;\n}\n.anna-rich-composer {\n    min-width: 0;\n    width: 100%;\n}\n.anna-rich-composer .ql-container,\n.anna-rich-composer .ql-editor {\n    background: transparent;\n    border: 0;\n    color: var(--anna-ink) !important;\n    font-size: 16px !important;\n    line-height: 24px !important;\n}\n.anna-rich-composer .ql-editor {\n    min-height: 48px;\n    padding: 0 4px !important;\n    overflow-y: visible !important;\n}\n.anna-rich-composer .ql-container > .ql-editor > p {\n    line-height: 24px;\n}\n.anna-rich-composer .ql-container > .ql-editor.ql-blank::before {\n    color: var(--anna-placeholder);\n    /* Match the editor's text inset instead of the shared task placeholder offsets. */\n    top: 0;\n    left: 4px !important;\n    right: 4px !important;\n}\n.anna-composer-field:focus-within {\n    border-color: var(--anna-focus);\n    box-shadow: 0 0 0 1px var(--anna-focus);\n}\n.anna-shell .anna-rich-composer .ql-editor:focus-visible {\n    outline: none;\n}\n.anna-composer-toolbar,\n.anna-composer-tools,\n.anna-composer-actions {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n.anna-composer-toolbar {\n    justify-content: space-between;\n}\n.anna-composer-attachment {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    width: 40px;\n    height: 40px;\n    flex: none;\n}\n.anna-send {\n    width: 40px;\n    height: 40px;\n    flex: none;\n    display: grid;\n    place-items: center;\n    padding: 0;\n    border: 0;\n    border-radius: 50%;\n    background: var(--anna-accent);\n    color: white;\n    transition:\n        box-shadow 150ms ease,\n        opacity 150ms ease;\n}\n.anna-send:not(:disabled):hover {\n    box-shadow: 0 2px 8px #0c66ff33;\n}\n.anna-voice-button {\n    width: 40px;\n    height: 40px;\n    flex: none;\n    display: grid;\n    place-items: center;\n    padding: 0;\n    border: 0;\n    border-radius: 50%;\n    background: transparent;\n    color: var(--anna-muted);\n}\n.anna-voice-button:hover {\n    background: var(--anna-hover);\n}\n.anna-voice-active,\n.anna-voice-active:hover {\n    color: #a12f36;\n    background: #fbefef;\n}\n.anna-composer-footer {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    font-size: 11px;\n    color: var(--anna-muted);\n    padding: 8px 4px 2px;\n    white-space: nowrap;\n    min-width: 0;\n}\n.anna-composer-footer > span {\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n.anna-composer-shortcut {\n    flex: none;\n}\n.anna-composer-footer-idle {\n    justify-content: flex-end;\n}\n.anna-call-audio {\n    position: absolute;\n    inset: 0;\n    padding: 14px 12px 10px;\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    gap: 8px;\n}\n.anna-call-summary {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 12px;\n    min-height: 48px;\n    min-width: 0;\n}\n.anna-call-levels {\n    display: flex;\n    gap: 10px;\n    flex: none;\n}\n.anna-call-level {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 5px 8px;\n    border: 1px solid var(--anna-border);\n    border-radius: 12px;\n    background: var(--anna-surface);\n    color: #227c60;\n    --anna-meter-color: #36a77b;\n}\n.anna-call-level-output {\n    color: #5964bb;\n    --anna-meter-color: #7b87ed;\n}\n.anna-call-settings {\n    box-sizing: border-box;\n    display: flex;\n    flex-direction: column;\n    gap: 14px;\n    padding: 16px;\n    overflow: auto;\n    border: 1px solid #e4e9ee;\n    border-radius: 16px;\n    background: #fff;\n    color: #18283f;\n    box-shadow: 0 8px 32px #18283f24;\n    font:\n        14px / 1.4 -apple-system,\n        BlinkMacSystemFont,\n        'Segoe UI',\n        sans-serif;\n}\n.anna-call-settings * {\n    box-sizing: border-box;\n}\n.anna-call-settings-heading {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 8px;\n}\n.anna-call-settings-heading button {\n    display: grid;\n    place-items: center;\n    width: 32px;\n    height: 32px;\n    padding: 0;\n    border: 0;\n    border-radius: 50%;\n    color: #536786;\n    background: #f6f8fa;\n    cursor: pointer;\n}\n.anna-call-settings button:focus-visible,\n.anna-call-settings select:focus-visible {\n    outline: 2px solid #0c66ff;\n    outline-offset: 2px;\n}\n.anna-call-settings .anna-call-devices {\n    grid-template-columns: minmax(0, 1fr);\n}\n.anna-call-settings-button {\n    position: relative;\n    border: 1px solid var(--anna-border);\n}\n.anna-call-settings-warning,\n.anna-call-settings-error {\n    color: #a12f36;\n}\n.anna-call-notice-dot {\n    position: absolute;\n    top: 4px;\n    right: 4px;\n    width: 6px;\n    height: 6px;\n    border-radius: 50%;\n    background: currentColor;\n}\n.anna-call-sr-only {\n    position: absolute;\n    width: 1px;\n    height: 1px;\n    padding: 0;\n    margin: -1px;\n    overflow: hidden;\n    clip-path: inset(50%);\n    white-space: nowrap;\n}\n.anna-call-devices {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    gap: 12px;\n}\n.anna-call-device {\n    min-width: 0;\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n}\n.anna-call-device label {\n    display: flex;\n    flex-direction: column;\n    gap: 5px;\n    min-width: 0;\n}\n.anna-call-device-label {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    color: #536786;\n    font-size: 12px;\n}\n.anna-call-device select {\n    width: 100%;\n    min-width: 0;\n    min-height: 40px;\n    padding: 6px 8px;\n    border: 1px solid #e4e9ee;\n    border-radius: 8px;\n    background: #f9fafb;\n    color: #18283f;\n    font: inherit;\n    font-size: 14px;\n    text-overflow: ellipsis;\n}\n.anna-call-device-name {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    color: var(--anna-muted);\n    font-size: 12px;\n    min-height: 16px;\n}\n.anna-call-meter {\n    position: relative;\n    width: 7px;\n    height: 32px;\n    border-radius: 4px;\n    background: var(--anna-border);\n    overflow: hidden;\n}\n.anna-call-meter > div {\n    position: absolute;\n    bottom: 0;\n    width: 100%;\n    border-radius: inherit;\n    background: linear-gradient(to top, var(--anna-meter-color), #a4e9d1);\n    transition: height 80ms linear;\n}\n.anna-call-level-output .anna-call-meter > div {\n    background: linear-gradient(to top, var(--anna-meter-color), #c6ceff);\n}\n.anna-call-meter::after {\n    content: '';\n    position: absolute;\n    inset: 0;\n    background: repeating-linear-gradient(to top, transparent 0 6px, var(--anna-surface) 6px 8px);\n}\n.anna-call-hint,\n.anna-call-duration {\n    color: var(--anna-muted);\n    font-size: 11px;\n}\n.anna-call-duration {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-end;\n    gap: 2px;\n    min-width: 0;\n}\n.anna-call-duration > span:first-child {\n    max-width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.anna-call-clock {\n    color: var(--anna-ink);\n    font-size: 18px;\n    line-height: 24px;\n    font-variant-numeric: tabular-nums;\n    letter-spacing: 0.5px;\n}\n.anna-call-settings .anna-call-hint,\n.anna-call-settings .anna-call-device-name {\n    color: #536786;\n}\n.anna-composer-actions {\n    flex: none;\n}\n@container anna-composer (max-width: 420px) {\n    .anna-composer-footer-idle {\n        display: none;\n    }\n    .anna-call-devices {\n        grid-template-columns: minmax(0, 1fr);\n        gap: 10px;\n    }\n}\n.anna-end-call {\n    color: #a12f36;\n    background: #fbefef;\n    border: 1px solid #f2d2d5;\n    border-radius: 20px;\n    padding: 8px 12px;\n}\n.anna-duration {\n    font-size: 12px;\n    color: var(--anna-muted);\n}\n.anna-stage {\n    position: relative;\n    min-width: 0;\n    min-height: 0;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n}\n.anna-presence {\n    flex: 1;\n    min-height: 0;\n    overflow: auto;\n    padding: 32px;\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n    justify-content: center;\n    background: radial-gradient(ellipse at 50% 40%, var(--anna-tint) 0, var(--anna-surface) 48%, #fff 100%);\n}\n.anna-presence-kicker {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 12px;\n    color: var(--anna-muted);\n    margin-bottom: 32px;\n}\n.anna-portrait {\n    width: clamp(160px, 23vw, 330px);\n    aspect-ratio: 1;\n    border-radius: 50%;\n    padding: 9px;\n    border: 1px solid var(--anna-border);\n    box-shadow: 0 15px 70px #0c66ff14;\n    flex: none;\n}\n.anna-portrait img,\n.anna-portrait > span {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: 50%;\n    background: var(--anna-tint);\n    display: grid;\n    place-items: center;\n    font-size: 70px;\n    color: var(--anna-accent);\n}\n.anna-presence-live .anna-portrait {\n    border-color: var(--anna-focus);\n    box-shadow:\n        0 0 0 10px #0c66ff15,\n        0 15px 70px #0c66ff14;\n}\n.anna-presence-copy {\n    text-align: center;\n    margin: 30px 0 26px;\n}\n.anna-presence-copy h2 {\n    font-size: 34px;\n    font-weight: 400;\n    letter-spacing: -1px;\n    margin: 10px 0;\n}\n.anna-presence-copy p {\n    font-size: 14px;\n    color: var(--anna-muted);\n    line-height: 1.5;\n}\n.anna-quick-views {\n    display: flex;\n    gap: 10px;\n    flex-wrap: wrap;\n    justify-content: center;\n}\n.anna-quick-views button {\n    min-width: 110px;\n    display: flex;\n    gap: 24px;\n    justify-content: space-between;\n    background: #ffffff90;\n    border: 1px solid var(--anna-border);\n    border-radius: 10px;\n    padding: 13px 16px;\n    color: var(--anna-ink);\n    font-size: 13px;\n}\n.anna-workspace {\n    flex: 1;\n    min-height: 0;\n    min-width: 0;\n    flex-direction: column;\n    background: white;\n}\n.anna-workspace-content {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    min-height: 0;\n    min-width: 0;\n    overflow: hidden;\n    isolation: isolate;\n}\n.anna-pending {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    flex: none;\n    padding: 12px 16px;\n    background: var(--anna-tint);\n    font-size: 13px;\n}\n.anna-pending span {\n    flex: 1;\n}\n.anna-pending button,\n.anna-error button {\n    border: 1px solid var(--anna-border);\n    background: white;\n    border-radius: 6px;\n    padding: 6px 10px;\n    color: var(--anna-accent);\n}\n.anna-error {\n    color: #a3373c;\n    padding: 10px;\n    font-size: 13px;\n    line-height: 1.5;\n}\n.anna-empty {\n    flex: 1;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    flex-direction: column;\n    gap: 14px;\n    padding: 28px;\n}\n.anna-muted {\n    color: var(--anna-muted);\n    font-size: 13px;\n}\n.anna-text-button {\n    border: 0;\n    background: none;\n    color: var(--anna-accent);\n    padding: 8px;\n}\n.anna-latest {\n    align-self: center;\n    border: 1px solid var(--anna-border);\n    border-radius: 20px;\n    padding: 7px 14px;\n    color: var(--anna-accent);\n    background: white;\n}\n.anna-mobile-dock {\n    display: none;\n}\n/* AT-2928: shown while files are dragged over the chat pane. Never a hit target, so the\n   drag events keep landing on the pane's own elements underneath. */\n.anna-drop-overlay {\n    position: absolute;\n    inset: 8px;\n    z-index: 40;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border: 2px dashed var(--anna-focus);\n    border-radius: 16px;\n    background: rgba(240, 246, 255, 0.92);\n    pointer-events: none;\n}\n.anna-drop-overlay-card {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 8px;\n    padding: 16px 24px;\n    color: var(--anna-focus);\n    font-size: 15px;\n    font-weight: 600;\n    text-align: center;\n}\n@media (max-width: 760px) {\n    .anna-header-note {\n        display: none;\n    }\n    .anna-layout {\n        display: flex;\n        flex-direction: column-reverse;\n        position: relative;\n    }\n    .anna-stage {\n        flex: 0 0 30%;\n    }\n    .anna-conversation {\n        flex: 1;\n        border-right: 0;\n    }\n    .anna-presence {\n        flex-direction: row;\n        gap: 20px;\n        padding: 14px 20px;\n        justify-content: center;\n    }\n    .anna-presence-kicker,\n    .anna-quick-views {\n        display: none;\n    }\n    .anna-portrait {\n        width: 110px;\n        padding: 4px;\n    }\n    .anna-presence-copy {\n        margin: 0;\n        text-align: left;\n    }\n    .anna-presence-copy h2 {\n        font-size: 23px;\n    }\n    .anna-presence-copy p {\n        font-size: 12px;\n        max-width: 180px;\n        margin-bottom: 0;\n    }\n    .anna-presence-copy .anna-eyebrow {\n        font-size: 9px;\n    }\n    .anna-messages {\n        padding: 14px 16px;\n    }\n    .anna-welcome {\n        padding: 18px 4px;\n    }\n    .anna-welcome h1 {\n        font-size: 28px;\n    }\n    .anna-welcome p {\n        font-size: 13px;\n        margin-bottom: 16px;\n    }\n    .anna-suggestions {\n        flex-direction: row;\n        flex-wrap: wrap;\n    }\n    .anna-suggestions button {\n        font-size: 12px;\n        padding: 9px 10px;\n    }\n    .anna-composer {\n        margin: 0 14px;\n    }\n    .anna-composer-shortcut {\n        display: none;\n    }\n    .anna-has-workspace .anna-stage {\n        flex: 1;\n    }\n    .anna-has-workspace .anna-conversation {\n        flex: 0 0 auto;\n    }\n    .anna-has-workspace .anna-conversation .anna-messages {\n        display: none;\n    }\n    .anna-has-workspace .anna-mobile-dock {\n        display: flex;\n        gap: 10px;\n        align-items: center;\n        padding: 10px 16px;\n        width: 100%;\n        background: white;\n        border: 0;\n        font-size: 13px;\n        color: var(--anna-ink);\n    }\n    .anna-mobile-dock img {\n        width: 28px;\n        height: 28px;\n        border-radius: 50%;\n        object-fit: cover;\n    }\n    .anna-mobile-dock span:last-child {\n        margin-left: auto;\n    }\n    .anna-chat-expanded.anna-has-workspace .anna-conversation {\n        position: absolute;\n        bottom: 0;\n        width: 100%;\n        height: 78%;\n        z-index: 30;\n        border-radius: 18px 18px 0 0;\n        box-shadow: 0 -12px 45px #04142f30;\n        overflow: hidden;\n    }\n    .anna-chat-expanded.anna-has-workspace .anna-conversation .anna-messages {\n        display: block;\n    }\n    .app-keyboard-open .anna-shell .anna-stage {\n        flex-basis: 0;\n    }\n    .app-keyboard-open .anna-shell.anna-has-workspace .anna-conversation {\n        height: 100%;\n    }\n}\n\n/* Temporary overlays: the actual task/note DOM and text selection remain untouched. */\n.anna-highlight-overlay {\n    position: fixed;\n    inset: 0;\n    pointer-events: none;\n    z-index: 10000;\n}\n.anna-highlight-overlay span {\n    position: absolute;\n    pointer-events: none;\n    border-radius: 3px;\n    box-sizing: border-box;\n}\n.anna-highlight-marker {\n    background: rgba(255, 211, 64, 0.38);\n    border-bottom: 2px solid #c79100;\n}\n.anna-highlight-outline {\n    outline: 2px solid var(--anna-accent, #0c66ff);\n    outline-offset: 2px;\n    background: rgba(12, 102, 255, 0.08);\n}\n.anna-workspace-content {\n    position: relative;\n}\n.anna-highlight-caption {\n    position: absolute;\n    top: 8px;\n    right: 12px;\n    max-width: min(340px, calc(100% - 24px));\n    z-index: 31;\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    padding: 9px 12px;\n    border: 1px solid #d9bf6d;\n    border-radius: 9px;\n    color: #493d18;\n    background: #fff8db;\n    box-shadow: 0 3px 14px #493d1818;\n    font-size: 12px;\n}\n.anna-highlight-caption span {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.anna-highlight-caption button {\n    border: 0;\n    background: transparent;\n    color: inherit;\n    padding: 4px;\n}\n\n.anna-conversation,\n.anna-header,\n.anna-browser-surface,\n.anna-pending {\n    font-family: Roboto, Arial, sans-serif;\n    color: var(--anna-ink);\n}\n\n/* The workspace subtree stays in the same position in both layouts. */\n.anna-zoom-shell [hidden]:not(.anna-workspace-content *) {\n    display: none !important;\n}\n.anna-zoom-shell .anna-layout {\n    grid-template-columns: minmax(0, var(--anna-chat-width, 420px)) 6px minmax(0, 1fr);\n    position: relative;\n}\n.anna-zoom-shell .anna-stage {\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n}\n.anna-zoom-shell .anna-workspace {\n    display: flex;\n    flex: 1;\n    min-height: 0;\n}\n.anna-zoom-shell .anna-workspace-content {\n    display: flex;\n    flex: 1;\n    min-height: 0;\n    overflow: hidden;\n}\n.anna-zoom-shell .anna-workspace-content > * {\n    min-width: 0;\n}\n/* AT-2911: the app beside the chat is framed as the workspace the assistant acts on,\n   like a screen in a monitor. The bezel is a gray border of the same thickness on all\n   four sides and sits on the outermost box of the workspace column (.anna-stage), so it\n   fills the full width and height to the right of the divider. The white space between\n   bezel and app is padding of .anna-workspace, horizontal only: the app touches the\n   bezel's inner top and bottom edge. That padding is outside .anna-workspace-content,\n   the box useWorkspaceViewportOwner measures, so the floating \"+\", inline fixed overlays\n   and popover bounds start at the app's own edge with no compensation of their own. */\n.anna-zoom-active {\n    --anna-workspace-gutter: clamp(24px, 3.5vw, 48px);\n    --anna-workspace-bezel: 6px;\n    --anna-workspace-bezel-color: var(--anna-bezel);\n    --anna-workspace-radius: 14px;\n}\n@media (max-width: 1100px) {\n    .anna-zoom-active {\n        --anna-workspace-gutter: clamp(16px, 2.5vw, 24px);\n        --anna-workspace-radius: 12px;\n    }\n}\n@media (min-width: 761px) {\n    /* One border width for every edge; the stage clips its content to the inner\n       corners (outer radius minus bezel), as on a real display. */\n    .anna-zoom-active:not(.anna-chat-only) .anna-stage {\n        border: var(--anna-workspace-bezel) solid var(--anna-workspace-bezel-color);\n        border-radius: var(--anna-workspace-radius);\n        background: #fff;\n        transition: border-color 200ms ease;\n    }\n    .anna-zoom-active:not(.anna-chat-only) .anna-stage > .anna-workspace {\n        padding-inline: var(--anna-workspace-gutter);\n        background: #fff;\n    }\n    /* While a tool call changes the workspace, the bezel takes its accent: the chat visibly\n       drives it. Thinking and answering keep the default bezel (AT-2926). */\n    .anna-zoom-active:not(.anna-chat-only) .anna-stage.anna-stage-working {\n        border-color: var(--anna-accent);\n    }\n    .anna-zoom-active .anna-divider {\n        position: relative;\n        background: #fff;\n    }\n    .anna-zoom-active .anna-divider::before {\n        content: '';\n        position: absolute;\n        top: 0;\n        bottom: 0;\n        left: 0;\n        width: 1px;\n        background: var(--anna-border);\n    }\n    .anna-zoom-active .anna-divider::after {\n        content: '';\n        position: absolute;\n        top: 50%;\n        left: 1px;\n        width: 4px;\n        height: 40px;\n        margin-top: -20px;\n        border-radius: 2px;\n        background: var(--anna-border);\n        transition: background 150ms ease;\n    }\n    .anna-zoom-active .anna-divider:hover,\n    .anna-zoom-active .anna-divider:focus-visible {\n        background: #fff;\n    }\n    .anna-zoom-active .anna-divider:hover::after,\n    .anna-zoom-active .anna-divider:focus-visible::after {\n        background: var(--anna-focus);\n    }\n}\n.anna-working-label {\n    display: none;\n}\n@media (min-width: 761px) {\n    /* Rises from the middle of the bottom bezel like a notch, in the bezel's working\n       colour. Bottom rather than top: the app touches the top bezel, and a notch there\n       would cover the middle of Alldone's top bar. Never intercepts a click. */\n    .anna-working-label {\n        position: absolute;\n        z-index: 40;\n        bottom: 0;\n        left: 50%;\n        transform: translateX(-50%);\n        display: inline-flex;\n        align-items: center;\n        gap: 6px;\n        height: 18px;\n        max-width: calc(100% - 2 * var(--anna-workspace-gutter) - 32px);\n        padding: 0 10px;\n        border-radius: 9px 9px 0 0;\n        background: var(--anna-accent);\n        color: #fff;\n        font-family: Roboto, Arial, sans-serif;\n        font-size: 11px !important;\n        font-weight: 500;\n        line-height: 18px;\n        white-space: nowrap;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        pointer-events: none;\n    }\n    .anna-working-dot {\n        flex: none;\n        width: 6px;\n        height: 6px;\n        border-radius: 50%;\n        background: #fff;\n        animation: anna-working-pulse 1.4s ease-in-out infinite;\n    }\n}\n@keyframes anna-working-pulse {\n    0%,\n    100% {\n        opacity: 1;\n    }\n    50% {\n        opacity: 0.35;\n    }\n}\n@media (prefers-reduced-motion: reduce) {\n    .anna-working-dot {\n        animation: none;\n    }\n    .anna-zoom-active .anna-stage {\n        transition: none;\n    }\n}\n.anna-zoom-active .anna-workspace-content {\n    /* Inline fixed dialogs belong to Alldone, including its navigation. Body\n       portals keep browser coordinates and use the measured workspace bounds. */\n    transform: translateX(0);\n}\n.anna-zoom-shell .anna-conversation {\n    min-width: 0;\n}\n.anna-divider {\n    cursor: col-resize;\n    touch-action: none;\n    background: var(--anna-border);\n}\n.anna-divider:hover,\n.anna-divider:focus-visible {\n    background: var(--anna-focus);\n}\n.anna-surface-hidden {\n    position: absolute !important;\n    inset: 0;\n    visibility: hidden;\n    pointer-events: none;\n}\n.anna-fullscreen {\n    background: transparent;\n}\n.anna-fullscreen .anna-layout {\n    display: flex;\n    flex: 1;\n}\n.anna-fullscreen .anna-conversation,\n.anna-fullscreen .anna-divider {\n    display: none;\n}\n.anna-fullscreen .anna-stage {\n    flex: 1;\n}\n.anna-fullscreen .anna-workspace {\n    width: 100%;\n}\n.anna-date-divider {\n    text-align: center;\n    color: var(--anna-muted);\n    margin: 16px 0;\n    font-size: 12px;\n}\n.anna-browser-surface {\n    flex: 1;\n    min-height: 0;\n    overflow: auto;\n    background: var(--anna-surface);\n}\n.anna-vm-dot {\n    width: 6px;\n    height: 6px;\n    flex: none;\n    border-radius: 50%;\n    background: var(--anna-accent);\n}\n.anna-vm-dot-awaiting_user {\n    background: #b56b10;\n}\n.anna-vm-dot-completed,\n.anna-vm-dot-cancelled,\n.anna-vm-dot-interrupted {\n    background: var(--anna-muted);\n}\n.anna-vm-surface,\n.anna-vm-workspace {\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    min-height: 0;\n    min-width: 0;\n    font-family: Roboto, Arial, sans-serif;\n    color: var(--anna-ink);\n    background: var(--anna-surface);\n}\n.anna-vm-heading {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    gap: 16px;\n    padding: 20px;\n    border-bottom: 1px solid var(--anna-border);\n    background: white;\n}\n.anna-vm-identity {\n    min-width: 0;\n}\n.anna-vm-identity h2 {\n    margin: 6px 0;\n    font-size: 18px;\n    overflow-wrap: anywhere;\n}\n.anna-vm-identity .anna-muted {\n    font-size: 12px;\n    overflow-wrap: anywhere;\n}\n.anna-vm-status {\n    color: var(--anna-accent);\n    font-size: 12px;\n    font-weight: 500;\n}\n.anna-vm-paused-hint {\n    font-size: 13px;\n    margin-bottom: 16px;\n}\n.anna-vm-task-link {\n    color: var(--anna-accent);\n    flex-shrink: 0;\n    font-size: 12px !important;\n}\n.anna-vm-activity {\n    flex: 1;\n    min-height: 0;\n    overflow: auto;\n    padding: 20px;\n    overflow-wrap: anywhere;\n}\n.anna-vm-terminal {\n    background: #20232b;\n    color: #ebedf3;\n    padding: 20px;\n    border-radius: 10px;\n    min-height: 240px;\n}\n.anna-vm-terminal-label {\n    color: #a7adbc;\n    font-size: 11px;\n    margin-bottom: 18px;\n}\n.anna-vm-terminal pre {\n    font-family: 'SFMono-Regular', Consolas, 'Liberation Mono', monospace;\n    font-size: 13px;\n    line-height: 1.7;\n    white-space: pre-wrap;\n    overflow-wrap: anywhere;\n    margin: 0;\n}\n.anna-vm-cursor {\n    color: #aabcf4;\n}\n.anna-vm-actions {\n    display: flex;\n    flex-direction: column;\n    margin-top: 16px;\n}\n@media (max-width: 760px) {\n    .anna-vm-heading {\n        flex-wrap: wrap;\n        padding: 16px;\n    }\n    .anna-vm-activity {\n        padding: 12px;\n    }\n}\n.anna-browser-workspace {\n    padding: 16px;\n}\n.anna-browser-takeover {\n    padding: 16px;\n}\n.anna-browser-heading {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n    justify-content: space-between;\n}\n.anna-browser-heading > div {\n    min-width: 0;\n    overflow-wrap: anywhere;\n}\n.anna-browser-heading button {\n    flex: none;\n}\n.anna-browser-workspace button {\n    border: 1px solid var(--anna-border);\n    background: white;\n    border-radius: 7px;\n    padding: 8px 12px;\n}\n.anna-browser-frame {\n    margin: 12px 0;\n    background: var(--anna-border);\n}\n.anna-browser-frame img {\n    display: block;\n    width: 100%;\n    height: auto;\n}\n.anna-browser-controls form {\n    display: flex;\n    gap: 8px;\n    margin-bottom: 8px;\n}\n.anna-browser-controls input {\n    min-width: 0;\n    flex: 1;\n    padding: 8px;\n    border: 1px solid var(--anna-border);\n    border-radius: 6px;\n    font-size: 16px;\n}\n.anna-browser-controls > div {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 6px;\n}\n.anna-small {\n    font-size: 12px;\n    color: var(--anna-muted);\n    margin-top: 8px;\n}\n@media (max-width: 760px) {\n    .anna-zoom-shell .anna-layout {\n        display: flex;\n        flex-direction: column;\n        position: relative;\n    }\n    .anna-zoom-shell .anna-divider {\n        display: none;\n    }\n    .anna-zoom-shell .anna-stage,\n    .anna-zoom-shell .anna-conversation {\n        flex: 1;\n        min-height: 0;\n    }\n    .anna-zoom-active.anna-mobile-chat .anna-stage,\n    .anna-zoom-active.anna-mobile-workspace .anna-conversation {\n        position: absolute;\n        inset: 0;\n        visibility: hidden;\n        pointer-events: none;\n    }\n    .anna-fullscreen .anna-stage {\n        visibility: visible;\n        position: relative;\n    }\n    .anna-browser-heading {\n        flex-wrap: wrap;\n    }\n}\n\n/* A visual receipt for Anna's saved work, clipped to the Alldone pane. */\n.anna-reveal-overlay {\n    position: fixed;\n    inset: 0;\n    z-index: 9998;\n    pointer-events: none;\n    animation: anna-reveal-lifetime 3.6s ease both;\n}\n.anna-reveal-ring {\n    box-sizing: border-box;\n    position: absolute;\n    border: 2px solid #438eff;\n    border-radius: 12px;\n    background: rgba(55, 130, 255, 0.055);\n    box-shadow: 0 0 0 4px rgba(55, 130, 255, 0.07);\n    animation: anna-reveal-pulse 1.25s ease-in-out 2;\n}\n.anna-reveal-label {\n    box-sizing: border-box;\n    position: absolute;\n    display: flex;\n    align-items: center;\n    gap: 7px;\n    height: 27px;\n    padding: 0 10px 0 6px;\n    border: 1px solid #d7e7ff;\n    border-radius: 999px;\n    color: #175bc5;\n    background: rgba(255, 255, 255, 0.96);\n    box-shadow: 0 3px 12px #205eaf14;\n    font:\n        500 12px Roboto,\n        Arial,\n        sans-serif;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n.anna-reveal-check {\n    flex-shrink: 0;\n    display: grid;\n    place-items: center;\n    width: 17px;\n    height: 17px;\n    border-radius: 50%;\n    background: #eaf3ff;\n}\n.anna-reveal-label-text {\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n@keyframes anna-reveal-lifetime {\n    0% {\n        opacity: 0;\n    }\n    9%,\n    82% {\n        opacity: 1;\n    }\n    100% {\n        opacity: 0;\n    }\n}\n@keyframes anna-reveal-pulse {\n    0%,\n    100% {\n        box-shadow: 0 0 0 3px #3782ff0c;\n        border-color: #438eff;\n    }\n    48% {\n        box-shadow:\n            0 0 0 7px #3782ff18,\n            0 4px 20px #3782ff0d;\n        border-color: #8ab7ff;\n    }\n}\n@media (prefers-reduced-motion: reduce) {\n    .anna-message,\n    .anna-message-answer,\n    .anna-reveal-overlay,\n    .anna-reveal-ring {\n        animation: none;\n    }\n    .anna-composer-field,\n    .anna-send,\n    .anna-call-meter > div {\n        transition: none;\n    }\n}\n\n@keyframes anna-message-arrive {\n    from {\n        opacity: 0;\n        transform: translateY(3px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n@keyframes anna-answer-arrive {\n    from {\n        opacity: 0.65;\n    }\n    to {\n        opacity: 1;\n    }\n}\n\n/* Pane controls belong to the conversation, leaving the workspace full height. */\n.anna-pane-toggle {\n    display: grid;\n    place-items: center;\n    flex: none;\n    width: 32px;\n    height: 36px;\n    padding: 0;\n    border: 0;\n    border-radius: 6px;\n    background: transparent;\n    color: var(--anna-muted);\n}\n.anna-pane-toggle:hover {\n    background: var(--anna-tint);\n    color: var(--anna-accent);\n}\n.anna-header-picker {\n    position: relative;\n    flex: 0 1 98px;\n    min-width: 0;\n}\n.anna-header-picker select {\n    max-width: 100%;\n    font-family: inherit;\n    color: var(--anna-ink);\n    border: 1px solid var(--anna-border);\n    border-radius: 7px;\n    background: white;\n    cursor: pointer;\n}\n.anna-header-picker select {\n    width: 98px;\n    height: 36px;\n    padding: 6px 24px 6px 9px;\n    font-size: 12px;\n    appearance: none;\n}\n.anna-header-picker > span {\n    position: absolute;\n    right: 7px;\n    top: 10px;\n    pointer-events: none;\n}\n.anna-shell select:focus-visible {\n    outline: 2px solid var(--anna-accent);\n    outline-offset: 2px;\n}\n.anna-chat-only .anna-layout {\n    grid-template-columns: minmax(0, 1fr);\n}\n.anna-chat-only .anna-divider {\n    display: none;\n}\n.anna-chat-only .anna-conversation {\n    border-right: 0;\n}\n.anna-chat-only .anna-messages {\n    padding-inline: max(24px, calc((100% - 760px) / 2));\n}\n.anna-chat-only .anna-composer {\n    width: calc(100% - 44px);\n    max-width: 760px;\n    margin-inline: auto;\n}\n.anna-chat-only .anna-stage {\n    position: absolute;\n    inset: 0 0 0 auto;\n    width: max(0px, calc(100% - var(--anna-chat-width) - 6px));\n    visibility: hidden;\n    pointer-events: none;\n}\n.anna-vms {\n    position: relative;\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    min-height: 0;\n    min-width: 0;\n    overflow: auto;\n    gap: 16px;\n    padding: 16px;\n    background: var(--anna-surface);\n}\n.anna-vms .anna-vm-surface {\n    flex: none;\n    border: 1px solid var(--anna-border);\n    border-radius: 12px;\n    overflow: hidden;\n}\n.anna-vms .anna-vm-selected {\n    border-color: var(--anna-accent);\n}\n.anna-vm-surface:focus-visible {\n    outline: 2px solid var(--anna-accent);\n    outline-offset: 3px;\n}\n.anna-vms .anna-vm-activity {\n    flex: none;\n    max-height: min(480px, 60dvh);\n}\n@media (max-width: 760px) {\n    .anna-vms {\n        gap: 12px;\n        padding: 12px;\n    }\n    .anna-chat-only .anna-stage {\n        width: 100%;\n    }\n    .anna-header {\n        padding: 12px 16px;\n        gap: 6px;\n    }\n    .anna-pane-toggle,\n    .anna-header-tasks,\n    .anna-header-picker select {\n        height: 44px;\n    }\n    .anna-pane-toggle {\n        width: 40px;\n    }\n    .anna-header-picker > span {\n        top: 14px;\n    }\n    .anna-header-assistant {\n        min-height: 44px;\n    }\n}\n@media (max-width: 360px) {\n    .anna-header .anna-small-avatar {\n        display: none;\n    }\n}\n\n/* AT-2903: project chip in the composer toolbar and its menu. The menu renders in\n   a body portal, outside .anna-shell, so every colour carries a fallback. */\n.anna-composer-tools {\n    min-width: 0;\n}\n.anna-project-chip {\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    min-width: 0;\n    max-width: 220px;\n    height: 32px;\n    padding: 0 8px 0 10px;\n    border: 1px solid var(--anna-border, #dfe3ea);\n    border-radius: 16px;\n    background: white;\n    color: var(--anna-ink, #04142f);\n    font: inherit;\n    font-size: 12px;\n    cursor: pointer;\n}\n.anna-project-chip:hover:not(:disabled) {\n    background: var(--anna-hover, #eef4ff);\n}\n.anna-project-chip:disabled {\n    cursor: default;\n    opacity: 0.55;\n}\n.anna-project-chip:focus-visible {\n    outline: 2px solid var(--anna-accent, #0c66ff);\n    outline-offset: 2px;\n}\n.anna-project-chip-busy .anna-project-chip-name {\n    opacity: 0.6;\n}\n.anna-project-chip-name {\n    min-width: 0;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.anna-project-dot {\n    flex: none;\n    width: 10px;\n    height: 10px;\n    border-radius: 50%;\n    background: var(--anna-neutral, #b9c1cf);\n}\n.anna-project-menu {\n    box-sizing: border-box;\n    font-family: Roboto, Arial, sans-serif;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    width: min(320px, calc(100vw - 24px));\n    max-height: min(360px, 60dvh);\n    padding: 8px;\n    border: 1px solid #dfe3ea;\n    border-radius: 12px;\n    background: white;\n    box-shadow: 0 8px 24px #04142f26;\n    color: #04142f;\n    font-size: 13px;\n}\n.anna-project-search {\n    box-sizing: border-box;\n    width: 100%;\n    height: 34px;\n    padding: 6px 10px;\n    border: 1px solid #dfe3ea;\n    border-radius: 8px;\n    font: inherit;\n}\n.anna-project-options {\n    margin: 0;\n    padding: 0;\n    list-style: none;\n    overflow-y: auto;\n    min-height: 0;\n}\n.anna-project-option {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n    width: 100%;\n    padding: 8px;\n    border: 0;\n    border-radius: 8px;\n    background: transparent;\n    color: inherit;\n    font: inherit;\n    text-align: left;\n    cursor: pointer;\n}\n.anna-project-option:hover,\n.anna-project-option:focus-visible {\n    background: #eef4ff;\n    outline: none;\n}\n.anna-project-option-selected {\n    color: #0c66ff;\n}\n.anna-project-option-text {\n    display: flex;\n    flex-direction: column;\n    flex: 1;\n    min-width: 0;\n}\n.anna-project-option-text > * {\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n.anna-project-option-text > span {\n    color: #536786;\n    font-size: 11px;\n}\n.anna-project-menu .anna-muted {\n    margin: 4px 8px;\n    color: #536786;\n}\n@container anna-composer (max-width: 420px) {\n    .anna-project-chip {\n        max-width: 132px;\n    }\n}\n/* Keep a readable part of the name on the narrowest phones: the chip gives up\n   its chevron and spacing before it gives up the project name. */\n@container anna-composer (max-width: 340px) {\n    .anna-composer-toolbar,\n    .anna-composer-tools,\n    .anna-composer-actions {\n        gap: 4px;\n    }\n    .anna-project-chip {\n        flex: 0 1 auto;\n        min-width: 72px;\n        padding: 0 8px;\n        gap: 5px;\n    }\n    .anna-project-chip > :last-child {\n        display: none;\n    }\n}\n/* MCP Apps views (e.g. Judy) opened from the chat: one fills the pane, the others stay mounted. */\n.anna-apps {\n    position: relative;\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    min-height: 0;\n    min-width: 0;\n    background: var(--anna-surface);\n}\n.anna-app-surface {\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n    min-height: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
